var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import logger from "@ane/core/lib/services/logging/Logger";
import { requestPendingOrCompleted, getCompletedAsyncWrapperObj, AsyncRequestStatus, getDefaultAsyncWrapperObj, requestCompleted, allRequestsHaveCompleted } from "@ane/core/lib/models";
import { compareIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { OperationCheckTypes, AdapterForwardedFromHeader, AdapterForwardedFromValues, ApprovalEntityType, FlightType, GateState, StudyOperations } from "@ane/exp-data/lib/models";
import experimentResource from "@ane/exp-data/lib/resources/ExperimentResourcesForProgression";
import featureResource from "@ane/exp-data/lib/resources/FeatureResources";
import AnalysisResourceV2 from "@ane/exp-data/lib/resources/expapiv2/Analysis.resource";
import { constructProgressionCloneGroups, findProgressionInProgressionCloneGroups, getProgressionInProgressionCloneGroups } from "@ane/exp-data/lib/utils/FeatureUtils";
import { MasterDataUtilInstance } from "@ane/exp-data/lib/utils/MasterDataUtils";
import { ProgressionSelectionUtilInstance } from "@ane/exp-data/lib/utils/ProgressionSelectionUtils";
import { ProgressionUtilsInstance } from "@ane/exp-data/lib/utils/ProgressionUtils";
import { TrafficFilterUtilInstance } from "@ane/exp-data/lib/utils/TrafficFilterUtils";
import * as _ from "lodash";
import ___default from "lodash";
import GatingResource from "@ane/exp-data/lib/resources/GatingResource";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import overrideResource from "@ane/exp-data/lib/resources/OverrideResource";
import { getExperimentationGroupIdFromPath, getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
import { aggregateAction, actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import { getDefaultFeatureMetadata, getInitialFlightList } from "@ane/exp-data/lib/defaultData/FeatureInitialData";
import { createSelectorCreator, defaultMemoize } from "reselect";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import BudgetResources from "@ane/exp-data/lib/resources/BudgetResources";
import FeatureResources from "@ane/exp-data/lib/resources/FeatureReadV2Resource";
import { combineEpics } from "redux-observable";
import { nomalizeProgressionResult, normalizeSingleProgressionResult } from "./module/utils/progression/Progression.utils.js";
import { checkProgressionsFullLoad, checkAlertsFullLoad, checkProgressionsScorecardsFullLoad, checkOverviewMainFunctionality } from "./module/actions/FeatureRolloutLogPerformanceActions.js";
import { loadMdsControlTowerExperienceEpicReducer as loadMdsControlTowerExperienceEpicReducer$1, loadMdsAnalysisConfigEpicReducer as loadMdsAnalysisConfigEpicReducer$1, loadAnalysisGroupEpicReducer, loadRootFeatureEpicReducer as loadRootFeatureEpicReducer$1 } from "@ane/progression-scorecard-app-module/lib/module/views/AnalysisTemplate/ProgressionScorecard/ProgressionScorecard.ducks";
import ProgressionsUtils from "./module/utils/Progressions.utils.js";
import { currentFeatureIdActionCreator } from "./module/reducers/CurrentProgressionReducer.js";
import { getMdsSection, MasterDataSections, getMdsSnapshotSection, getMdsDefaultSnapshotSection, MasterDataPermissions } from "./module/reducers/mdsData.ducks.utils.js";
import AssignmentUnitResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import ExperimentationGroupResourceV2 from "@ane/exp-data/lib/resources/expapiunified/ExperimentationGroup.resource";
import IsolationGroupResource from "@ane/exp-data/lib/resources/expapiv2/IsolationGroups.resource";
import { TelemetryEventName } from "@ane/core/lib/services/MSALAuthService/TelemetryEventName";
import { isUsingWPSWorkspace } from "@ane/core/lib/utils/WPSUtils";
import WPSResource from "@ane/exp-data/lib/resources/WPSResource";
import { createAction } from "@reduxjs/toolkit";
import { loadAssignmentDetailsForExperimentEpicReducer } from "@ane/exp-data/lib/assignmentDetailsV2";
import { ProgressionsTelemetryMetricNames } from "@ane/exp-data/lib/telemetry/ProgressionsTelemetryMetricNames";
import { showVNextProgressionPage } from "@ane/exp-data/lib/utils/UnifiedViewUtils";
import experimentReadV2Resource from "@ane/exp-data/lib/resources/ExperimentReadV2Resource";
import AlertResources from "@ane/expalert/lib/module/views/Alert/resources/AlertResources";
import AlertUtils from "@ane/expalert/lib/module/views/Alert/utils/AlertUtils";
import { parseFeature } from "./module/utils/FeatureParser.js";
import { CommonUtilsInstance } from "@ane/core/lib/utils/CommonUtils";
import { featureUtilsV2Instance } from "@ane/exp-data/lib/utils/FeatureUtilsV2";
import operationCheckUtils from "@ane/exp-data/lib/utils/OperationCheckUtils";
import { progressionStageUtils } from "./module/utils/ProgressionStageUtils.js";
import { gatingUtils } from "@ane/exp-data/lib/utils/GatingUtils";
import { getRouteLocationSearchGroup } from "@ane/core/lib/services/syncUrlAndStore/RouteUpdate.selectors";
import { convertFilterPolicyV2 } from "@ane/exp-data/lib/utils/AudienceFilter.utils";
import { getWSSPlitMigrationDataSelector } from "@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.selectors";
import { getMigrationDataByNewExperimentationGroupId, getExperimentationGroupMigationData } from "@ane/exp-data/lib/utils/WorkspaceMigrationData";
import { getTenantFromManagementGroup as getTenantFromManagementGroup$1 } from "@ane/exp-data/lib/utils/ManagementGroup";
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
let OverrideActions = class {
  resetOverrideActionsState() {
    return null;
  }
  createOverrideSet(overrideSet, tenant, featureId, mdsFilters) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        let overrideSetId = yield overrideResource.createOverrideSet(tenant, featureId, overrideSet);
        dispatch(this.loadOverrideSet(overrideSetId, featureId, tenant, mdsFilters));
      });
      return inner;
    });
  }
  createOverrideSetStage(overrideSetId, overrideSetStage, tenant, featureId, mdsFilters) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        yield overrideResource.createOverrideSetStage(overrideSetId, tenant, featureId, overrideSetStage);
        dispatch(this.loadOverrideSet(overrideSetId, featureId, tenant, mdsFilters));
      });
      return inner;
    });
  }
  loadOverrideSetsForFeature(featureId, tenant, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        var _a;
        let result = yield dispatch(
          this.loadOverrideSetsForFeatureInternal(featureId, tenant, workspaceId, managementGroup)
        );
        const promiseList = [];
        (_a = result.payload.overrideSets) == null ? void 0 : _a.forEach((overrideSet) => {
          promiseList.push(dispatch(this.fetchOverrideOperationCheck(overrideSet.Id)));
        });
        promiseList.push(dispatch(gatingActions.loadActiveGatesForFeature()));
        return new Promise((resolve) => Promise.all(promiseList).then(() => resolve()));
      });
      return inner;
    });
  }
  loadOverrideSetsForFeatureInternal(featureId, tenant, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      let experimentTrafficFilters = null;
      workspaceId = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      const experimentationGroup = getExperimentationGroupIdFromPath(workspaceId, managementGroup);
      experimentTrafficFilters = yield MdsDataplaneResources.getConfigWithType({
        workspaceId,
        experimentationGroup,
        section: MasterDataConstants.experimentTrafficFiltersSection
      });
      const result = yield overrideResource.getOverrideSetsForFeature(featureId, tenant);
      return {
        overrideSets: result,
        mdsFilters: experimentTrafficFilters
      };
    });
  }
  handleOperationRequest(overrideSetId, featureId, tenant, mdsFilters, operationType) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        switch (operationType) {
          case OperationCheckTypes.Advance:
            yield overrideResource.advanceOverrideSet(overrideSetId, featureId, tenant);
            break;
          case OperationCheckTypes.Start:
            yield overrideResource.startOverrideSet(overrideSetId, featureId, tenant);
            break;
          case OperationCheckTypes.Stop:
            yield overrideResource.stopOverrideSet(overrideSetId, featureId, tenant);
            break;
          default:
            break;
        }
        dispatch(this.loadOverrideSet(overrideSetId, featureId, tenant, mdsFilters));
      });
      return inner;
    });
  }
  loadOverrideSet(overrideSetId, featureId, tenant, mdsFilters) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(this.loadOverrideSetInternal(overrideSetId, featureId, tenant, mdsFilters));
        dispatch(this.fetchOverrideOperationCheck(overrideSetId));
        dispatch(gatingActions.loadActiveGatesForFeature());
      });
      return inner;
    });
  }
  loadOverrideSetInternal(overrideSetId, featureId, tenant, mdsFilters) {
    return __async(this, null, function* () {
      const overrideSet = yield overrideResource.getOverrideSet(overrideSetId, featureId, tenant);
      return {
        overrideSet,
        mdsFilters
      };
    });
  }
  fetchOverrideOperationCheck(overrideSetId) {
    return __async(this, null, function* () {
      const operationCheckCall = yield experimentResource.getOperationChecksForExperiment(overrideSetId);
      const isCallSuccessful = operationCheckCall.isSuccessful();
      return {
        id: overrideSetId,
        operationChecks: isCallSuccessful ? operationCheckCall.getSuccessData() : null,
        error: !isCallSuccessful ? "Error in fetching operation checks" : null,
        errorDetails: !isCallSuccessful ? `The result wasn't successful (${operationCheckCall.statusCode})-${operationCheckCall.statusText}` : null
      };
    });
  }
  // TODO: consider moving this to a base class so we don't need to repeat this is multiple actions
  updateGates(entityGateMapping) {
    return __async(this, null, function* () {
      return entityGateMapping;
    });
  }
  hideOverrideSet(overrideSetId, featureId, tenant, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield overrideResource.setOverrideSetHidden(overrideSetId, featureId, tenant, true);
        dispatch(this.loadOverrideSetsForFeature(featureId, tenant, workspaceId, managementGroup));
      });
      return inner;
    });
  }
  hideOverrideStage(overrideSetId, stage, featureId, tenant, workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield overrideResource.setOverrideStageHidden(featureId, overrideSetId, stage.id, tenant);
        dispatch(this.loadOverrideSetsForFeature(featureId, tenant, workspaceId, managementGroup));
      });
      return inner;
    });
  }
};
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "createOverrideSet", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "createOverrideSetStage", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "loadOverrideSetsForFeature", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "handleOperationRequest", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "loadOverrideSet", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "hideOverrideSet", 1);
__decorateClass$2([
  aggregateAction()
], OverrideActions.prototype, "hideOverrideStage", 1);
OverrideActions = __decorateClass$2([
  actionClass()
], OverrideActions);
const overrideActions = new OverrideActions();
const reduxActionTypePrefix$1 = "ProgressionActions";
const updateMissingSnapshotNames = createAction("UPDATE_MISSING_SNAPSHOT_NAMES");
var IReducerKeys$1 = /* @__PURE__ */ ((IReducerKeys2) => {
  IReducerKeys2["mds_data"] = "mds_data";
  IReducerKeys2["mds_snapshot_data"] = "mds_snapshot_data";
  IReducerKeys2["mds_workspace_data"] = "mds_workspace_data";
  IReducerKeys2["mds_missing_snapshot_names"] = "mds_missing_snapshot_names";
  IReducerKeys2["mds_default_snapshots"] = "mds_default_snapshots";
  IReducerKeys2["mds_snapshots"] = "mds_snapshots";
  IReducerKeys2["mds_flight_control_async"] = "mds_flight_control_async";
  IReducerKeys2["mds_progression_templates_async"] = "mds_progression_templates_async";
  IReducerKeys2["mds_control_tower_experience_async"] = "mds_control_tower_experience_async";
  IReducerKeys2["mds_experiment_templates_async"] = "mds_experiment_templates_async";
  IReducerKeys2["mds_experiment_traffic_filters_async"] = "mds_experiment_traffic_filters_async";
  IReducerKeys2["mds_experiment_extensions_async"] = "mds_experiment_extensions_async";
  IReducerKeys2["mds_experiment_permission_async"] = "mds_experiment_permission_async";
  IReducerKeys2["mds_analysis_config_async"] = "mds_analysis_config_async";
  IReducerKeys2["eg_traffic_filters"] = "eg_traffic_filters";
  IReducerKeys2["workspace_assignment_units"] = "workspace_assignment_units";
  IReducerKeys2["workspace_isolation_groups"] = "workspace_isolation_groups";
  return IReducerKeys2;
})(IReducerKeys$1 || {});
const defaultReducerState$1 = () => ({
  [
    "mds_data"
    /* mds_data */
  ]: {},
  [
    "mds_snapshot_data"
    /* mds_snapshot_data */
  ]: {
    [
      "mds_snapshots"
      /* mds_snapshots */
    ]: {},
    [
      "mds_default_snapshots"
      /* mds_default_snapshots */
    ]: {}
  },
  [
    "mds_workspace_data"
    /* mds_workspace_data */
  ]: {},
  [
    "mds_missing_snapshot_names"
    /* mds_missing_snapshot_names */
  ]: []
});
const loadMdsFlightControlArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_FLIGHT_CONTROL`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_flight_control_async"
    /* mds_flight_control_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_flight_control_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.FlightControl),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsFlightControlEpicReducer = loadResourcesUtils(loadMdsFlightControlArgs);
const loadWorkspaceIsolationGroupsArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_WORKSPACE_ISOLATION_GROUPS`,
  reduxKeyNested: (inputPayload) => [
    "mds_workspace_data",
    inputPayload.workspaceId,
    "workspace_isolation_groups"
    /* workspace_isolation_groups */
  ],
  loadResource: ({ workspaceId }) => IsolationGroupResource.queryIsolationGroups(workspaceId, {
    filter: {
      isUserManaged: true
    }
  }),
  onCompleteSuccess: (result) => result
};
const loadWorkspaceIsolationGroupsEpicReducer = loadResourcesUtils(loadWorkspaceIsolationGroupsArgs);
const loadExperimentationGroupTrafficFiltersArgsV2 = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_EG_TRAFFIC_FILTERSV2`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "eg_traffic_filters"
    /* eg_traffic_filters */
  ],
  loadResource: ({ workspaceId, managementGroup, includeArchived }) => ExperimentationGroupResourceV2.getAudienceFilters({
    workspaceId,
    experimentationGroup: getExperimentationGroupIdFromPath(workspaceId, managementGroup),
    includeArchived
  }),
  onCompleteSuccess: (result) => result
};
const loadExperimentationGroupTrafficFiltersEpicReducerV2 = loadResourcesUtils(
  loadExperimentationGroupTrafficFiltersArgsV2
);
const loadWorkspaceAssignmentUnitsArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_WORKSPACE_ASSIGNMENT_UNITSV2`,
  reduxKeyNested: (inputPayload) => [
    "mds_workspace_data",
    inputPayload.workspaceId,
    "workspace_assignment_units"
    /* workspace_assignment_units */
  ],
  loadResource: ({ workspaceId }) => AssignmentUnitResource.queryAssignmentUnits(workspaceId),
  onCompleteSuccess: (result) => result
};
const loadWorkspaceAssignmentUnitsEpicReducer = loadResourcesUtils(loadWorkspaceAssignmentUnitsArgs);
const getLoadWorkspaceAssignmentUnitsEpicReducer = () => loadWorkspaceAssignmentUnitsEpicReducer;
const loadMdsProgressionTemplateArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_PROGRESSION_TEMPLATES`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_progression_templates_async"
    /* mds_progression_templates_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_progression_templates_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.ProgressionTemplates),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsProgressionTemplateEpicReducer = loadResourcesUtils(loadMdsProgressionTemplateArgs);
const loadMdsSnapshotProgressionTemplateArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_SNAPSHOT_PROGRESSION_TEMPLATES`,
  reduxKeyNested: (inputPayload) => [
    "mds_snapshot_data",
    "mds_snapshots",
    inputPayload.managementGroup,
    inputPayload.snapshotName,
    "mds_progression_templates_async"
    /* mds_progression_templates_async */
  ],
  dontLoad: ({ managementGroup, snapshotName }, state) => {
    var _a, _b, _c, _d, _e, _f;
    return requestPendingOrCompleted(
      (_f = (_e = (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_snapshot_data"]) == null ? void 0 : _b["mds_snapshots"]) == null ? void 0 : _c[managementGroup]) == null ? void 0 : _d[snapshotName]) == null ? void 0 : _e["mds_progression_templates_async"]) == null ? void 0 : _f.status
    );
  },
  loadResource: (payload) => getMdsSnapshotSection(payload, MasterDataSections.ProgressionTemplates),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: ({ rolloutId, progressionDtos, logInitialLoadPLT, managementGroup, snapshotName }, outputPayload, state) => {
    const updatedState = _.cloneDeep(state);
    _.set(
      updatedState,
      [
        "mds",
        "mds_snapshot_data",
        "mds_snapshots",
        managementGroup,
        snapshotName,
        "mds_progression_templates_async"
        /* mds_progression_templates_async */
      ],
      getCompletedAsyncWrapperObj(outputPayload)
    );
    if (!outputPayload) {
      return [updateMissingSnapshotNames(snapshotName)];
    }
    if (!!rolloutId && !!progressionDtos) {
      return getProgressionStageOperationsActions({ state: updatedState, rolloutId, progressionDtos, logInitialLoadPLT });
    } else {
      return [];
    }
  }
};
const loadMdsSnapshotProgressionTemplateEpicReducer = loadResourcesUtils(loadMdsSnapshotProgressionTemplateArgs);
const loadMdsDefaultSnapshotProgressionTemplateArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_DEFAULT_SNAPSHOT_PROGRESSION_TEMPLATE`,
  reduxKeyNested: (inputPayload) => [
    "mds_snapshot_data",
    "mds_default_snapshots",
    inputPayload.workspaceId
  ],
  dontLoad: ({ workspaceId }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_snapshot_data"]) == null ? void 0 : _b["mds_default_snapshots"]) == null ? void 0 : _c[workspaceId]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsDefaultSnapshotSection(payload),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsDefaultSnapshotProgressionTemplateEpicReducer = loadResourcesUtils(
  loadMdsDefaultSnapshotProgressionTemplateArgs
);
const loadMdsControlTowerExperienceArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_CONTROL_TOWER_EXPERIENCE`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_control_tower_experience_async"
    /* mds_control_tower_experience_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_control_tower_experience_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.ControlTowerExperience),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    return [
      /** Hydrate the progressionScorecard Redux state */
      loadMdsControlTowerExperienceEpicReducer$1.actionCreators.loaded(
        inputPayload,
        getCompletedAsyncWrapperObj(outputPayload)
      )
    ];
  }
};
const loadMdsControlTowerExperienceEpicReducer = loadResourcesUtils(loadMdsControlTowerExperienceArgs);
const loadMdsExperimentTemplatesArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_EXPERIMENT_TEMPLATES`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_experiment_templates_async"
    /* mds_experiment_templates_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_experiment_templates_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.ExperimentTemplates),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsExperimentTemplatesEpicReducer = loadResourcesUtils(loadMdsExperimentTemplatesArgs);
const loadMdsAnalysisConfigArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_ANALYSIS_CONFIG`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_analysis_config_async"
    /* mds_analysis_config_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_analysis_config_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.AnalysisConfig),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const { CustomAnalysisRequiredInFeature = false } = outputPayload;
    const { experimentStepId = "", workspaceId = "" } = inputPayload;
    return [
      /** Hydrate the progressionScorecard Redux state */
      loadMdsAnalysisConfigEpicReducer$1.actionCreators.loaded(
        inputPayload,
        getCompletedAsyncWrapperObj(outputPayload)
      ),
      // Preload Scorecard data only if CustomAnalysisRequiredInFeature
      ...CustomAnalysisRequiredInFeature ? [loadAnalysisGroupEpicReducer.actionCreators.load({ experimentStepId, workspaceId })] : []
    ];
  }
};
const loadMdsAnalysisConfigEpicReducer = loadResourcesUtils(loadMdsAnalysisConfigArgs);
const loadMdsExperimentTrafficFiltersArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_MDS_EXPERIMENT_TRAFFIC_FILTERS`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_experiment_traffic_filters_async"
    /* mds_experiment_traffic_filters_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_experiment_traffic_filters_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.ExperimentTrafficFilters),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsExperimentTrafficFiltersEpicReducer = loadResourcesUtils(loadMdsExperimentTrafficFiltersArgs);
const loadMdsExperimentExtensionsArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_EXPERIMENT_EXTENSIONS`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_experiment_extensions_async"
    /* mds_experiment_extensions_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_experiment_extensions_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => getMdsSection(payload, MasterDataSections.ExperimentExtensions),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsExperimentExtensionsEpicReducer = loadResourcesUtils(loadMdsExperimentExtensionsArgs);
const loadMdsExperimentPermissionArgs = {
  actionPrefix: `${reduxActionTypePrefix$1}/LOAD_EXPERIMENT_PERMISSION`,
  reduxKeyNested: (inputPayload) => [
    "mds_data",
    inputPayload.managementGroup,
    "mds_experiment_permission_async"
    /* mds_experiment_permission_async */
  ],
  dontLoad: ({ managementGroup }, state) => {
    var _a, _b, _c, _d;
    return requestPendingOrCompleted(
      (_d = (_c = (_b = (_a = state == null ? void 0 : state.mds) == null ? void 0 : _a["mds_data"]) == null ? void 0 : _b[managementGroup]) == null ? void 0 : _c["mds_experiment_permission_async"]) == null ? void 0 : _d.status
    );
  },
  loadResource: (payload) => {
    var _a, _b, _c;
    logger.info(`${TelemetryEventName.WPS_User_Access_Check_ExpGroup_Claim}`, {
      needRequestToProxy: (_a = EnvironmentService.getWpsStatus()) == null ? void 0 : _a.needRequestToProxy,
      workspaceProxyEnabled: (_b = EnvironmentService.getWpsStatus()) == null ? void 0 : _b.workspaceProxyEnabled
    });
    const experimentationGroup = getExperimentationGroupIdFromPath(payload.workspaceId, payload.managementGroup);
    if (isUsingWPSWorkspace() && ((_c = EnvironmentService.getWpsStatus()) == null ? void 0 : _c.workspaceProxyEnabled)) {
      return WPSResource.isAuthorizedRestResult(
        payload.workspaceId,
        experimentationGroup,
        MasterDataPermissions.ExperimentPermission
      );
    } else {
      return MdsDataplaneResources.isAuthorizedRestResult(
        payload.workspaceId,
        experimentationGroup,
        MasterDataPermissions.ExperimentPermission
      );
    }
  },
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadMdsExperimentPermissionEpicReducer = loadResourcesUtils(loadMdsExperimentPermissionArgs);
const reducer$1 = (state = defaultReducerState$1(), action) => {
  state = loadMdsFlightControlEpicReducer.reduxChange(state, action);
  state = loadMdsProgressionTemplateEpicReducer.reduxChange(state, action);
  state = loadMdsControlTowerExperienceEpicReducer.reduxChange(state, action);
  state = loadMdsExperimentTemplatesEpicReducer.reduxChange(state, action);
  state = loadMdsExperimentTrafficFiltersEpicReducer.reduxChange(state, action);
  state = loadMdsExperimentExtensionsEpicReducer.reduxChange(state, action);
  state = loadMdsExperimentPermissionEpicReducer.reduxChange(state, action);
  state = loadMdsSnapshotProgressionTemplateEpicReducer.reduxChange(state, action);
  state = loadMdsDefaultSnapshotProgressionTemplateEpicReducer.reduxChange(state, action);
  state = loadMdsAnalysisConfigEpicReducer.reduxChange(state, action);
  state = loadExperimentationGroupTrafficFiltersEpicReducerV2.reduxChange(state, action);
  state = loadWorkspaceAssignmentUnitsEpicReducer.reduxChange(state, action);
  state = loadWorkspaceIsolationGroupsEpicReducer.reduxChange(state, action);
  if (updateMissingSnapshotNames.match(action)) {
    return __spreadProps(__spreadValues({}, state), {
      [
        "mds_missing_snapshot_names"
        /* mds_missing_snapshot_names */
      ]: [...state[
        "mds_missing_snapshot_names"
        /* mds_missing_snapshot_names */
      ], action.payload]
    });
  }
  return state;
};
const epics$1 = combineEpics(
  loadMdsFlightControlEpicReducer.epic,
  loadMdsProgressionTemplateEpicReducer.epic,
  loadMdsControlTowerExperienceEpicReducer.epic,
  loadMdsExperimentTemplatesEpicReducer.epic,
  loadMdsExperimentTrafficFiltersEpicReducer.epic,
  loadMdsExperimentExtensionsEpicReducer.epic,
  loadMdsExperimentPermissionEpicReducer.epic,
  loadMdsSnapshotProgressionTemplateEpicReducer.epic,
  loadMdsDefaultSnapshotProgressionTemplateEpicReducer.epic,
  loadMdsAnalysisConfigEpicReducer.epic,
  loadExperimentationGroupTrafficFiltersEpicReducerV2.epic,
  loadWorkspaceAssignmentUnitsEpicReducer.epic,
  loadWorkspaceIsolationGroupsEpicReducer.epic
);
const setFeatureProgressionsLoading = (state = defaultReducerState(), input) => {
  var _a;
  return {
    [input.featureId]: __spreadProps(__spreadValues({}, state.features[input.featureId]), {
      [IReducerKeys.progression_list_async]: __spreadProps(__spreadValues({}, (_a = state.features[input == null ? void 0 : input.featureId]) == null ? void 0 : _a[IReducerKeys.progression_list_async]), {
        status: AsyncRequestStatus.Pending
      })
    })
  };
};
const setFeatureInReduxWhenProgressionsLoaded = (state = defaultReducerState(), input, resultProgressionIds, asyncData) => {
  var _a, _b, _c, _d, _e;
  const previousProgressions = (_d = (_c = (_b = (_a = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _a[input.featureId]) == null ? void 0 : _b[IReducerKeys.progression_list_async]) == null ? void 0 : _c.data) != null ? _d : [];
  return {
    [input == null ? void 0 : input.featureId]: __spreadProps(__spreadValues({}, (_e = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _e[input.featureId]), {
      [IReducerKeys.progression_list_async]: __spreadProps(__spreadValues({}, asyncData), {
        data: ___default.uniq([...previousProgressions, ...!!resultProgressionIds ? resultProgressionIds : []])
      })
    })
  };
};
const setFeatureInReduxWhenSingleProgressionLoaded = (state = defaultReducerState(), input, resultProgressionId, asyncData) => {
  var _a, _b, _c, _d, _e;
  const previousProgressions = (_d = (_c = (_b = (_a = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _a[input.featureId]) == null ? void 0 : _b[IReducerKeys.progression_list_async]) == null ? void 0 : _c.data) != null ? _d : [];
  return {
    [input == null ? void 0 : input.featureId]: __spreadProps(__spreadValues({}, (_e = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _e[input.featureId]), {
      [IReducerKeys.progression_list_async]: __spreadProps(__spreadValues({}, asyncData), {
        data: ___default.uniq([...previousProgressions, ...!!resultProgressionId ? [resultProgressionId] : []])
      })
    })
  };
};
const setProgressionsInReduxWhenProgressionsLoaded = (state = defaultReducerState(), resultProgressions, asyncData) => {
  return ___default.reduce(
    resultProgressions != null ? resultProgressions : {},
    (result, value, key) => {
      var _a, _b;
      result[key] = __spreadProps(__spreadValues({}, (_b = (_a = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _a[key]) != null ? _b : defaultProgressionReduxData()), {
        [IReducerKeys.progression_normalized_async]: __spreadProps(__spreadValues({}, asyncData), {
          data: value
        })
      });
      return result;
    },
    __spreadValues({}, state[IReducerKeys.progressions_dict])
  );
};
const setProgressionStagesInReduxWhenProgressionsLoaded = (state = defaultReducerState(), resultProgressionStages, asyncData) => {
  return ___default.reduce(
    resultProgressionStages,
    (result, value, key) => {
      var _a, _b;
      result[key] = __spreadProps(__spreadValues({}, (_b = (_a = state == null ? void 0 : state[IReducerKeys.progression_stages_dict]) == null ? void 0 : _a[key]) != null ? _b : defaultProgressionStageReduxData()), {
        [IReducerKeys.progression_stage_async]: __spreadProps(__spreadValues({}, asyncData), {
          data: value
        })
      });
      return result;
    },
    __spreadValues({}, state[IReducerKeys.progression_stages_dict])
  );
};
const setProgressionInReduxWhenSingleProgressionLoading = (state = defaultReducerState(), input) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  return __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.features]), {
    [input.featureId]: __spreadProps(__spreadValues({}, (_a = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _a[input.featureId]), {
      [IReducerKeys.progression_list_async]: __spreadProps(__spreadValues({}, (_d = (_c = (_b = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _b[input.featureId]) == null ? void 0 : _c[IReducerKeys.progression_list_async]) != null ? _d : getCompletedAsyncWrapperObj([])), {
        data: [
          ...(_h = (_g = (_f = (_e = state == null ? void 0 : state[IReducerKeys.features]) == null ? void 0 : _e[input.featureId]) == null ? void 0 : _f[IReducerKeys.progression_list_async]) == null ? void 0 : _g.data) != null ? _h : [],
          input.progressionId
        ]
      })
    })
  });
};
const setProgressionDictInReduxWhenSingleProgressionLoading = (state = defaultReducerState(), input) => {
  var _a, _b, _c, _d, _e;
  return __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.progressions_dict]), {
    [input.progressionId]: __spreadProps(__spreadValues({}, (_b = (_a = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _a[input.progressionId]) != null ? _b : defaultProgressionReduxData()), {
      [IReducerKeys.progression_normalized_async]: __spreadProps(__spreadValues({}, (_e = (_d = (_c = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _c[input.progressionId]) == null ? void 0 : _d[IReducerKeys.progression_normalized_async]) != null ? _e : {}), {
        status: AsyncRequestStatus.Pending
      })
    })
  });
};
const setSingleProgressionStageInReduxLoading = (state = defaultReducerState(), input) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  return __spreadProps(__spreadValues({}, state), {
    [IReducerKeys.progressions_dict]: __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.progressions_dict]), {
      [input.progressionId]: __spreadProps(__spreadValues({}, (_b = (_a = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _a[input.progressionId]) != null ? _b : defaultProgressionReduxData()), {
        [IReducerKeys.progression_normalized_async]: __spreadProps(__spreadValues({}, (_e = (_d = (_c = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _c[input.progressionId]) == null ? void 0 : _d[IReducerKeys.progression_normalized_async]) != null ? _e : getDefaultAsyncWrapperObj()), {
          data: !!((_h = (_g = (_f = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _f[input.progressionId]) == null ? void 0 : _g[IReducerKeys.progression_normalized_async]) == null ? void 0 : _h.data) ? __spreadProps(__spreadValues({}, (_k = (_j = (_i = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _i[input.progressionId]) == null ? void 0 : _j[IReducerKeys.progression_normalized_async]) == null ? void 0 : _k.data), {
            Studies: ___default.uniq([
              ...(_p = (_o = (_n = (_m = (_l = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _l[input.progressionId]) == null ? void 0 : _m[IReducerKeys.progression_normalized_async]) == null ? void 0 : _n.data) == null ? void 0 : _o.Studies) != null ? _p : [],
              input.progressionStageId
            ])
          }) : null
        })
      })
    }),
    [IReducerKeys.progression_stages_dict]: __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.progression_stages_dict]), {
      [input.progressionStageId]: __spreadProps(__spreadValues({}, (_r = (_q = state == null ? void 0 : state[IReducerKeys.progression_stages_dict]) == null ? void 0 : _q[input.progressionStageId]) != null ? _r : defaultProgressionStageReduxData()), {
        [IReducerKeys.progression_stage_async]: __spreadProps(__spreadValues({}, (_t = (_s = state == null ? void 0 : state[IReducerKeys.progression_stages_dict]) == null ? void 0 : _s[input.progressionStageId]) == null ? void 0 : _t[IReducerKeys.progression_stage_async]), {
          status: AsyncRequestStatus.Pending
        })
      })
    })
  });
};
const setSingleProgressionStageInReduxLoaded = (state = defaultReducerState(), input, asyncData) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  return __spreadProps(__spreadValues({}, state), {
    [IReducerKeys.progressions_dict]: __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.progressions_dict]), {
      [input.progressionId]: __spreadProps(__spreadValues({}, (_b = (_a = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _a[input.progressionId]) != null ? _b : defaultProgressionReduxData()), {
        [IReducerKeys.progression_normalized_async]: __spreadProps(__spreadValues({}, (_e = (_d = (_c = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _c[input.progressionId]) == null ? void 0 : _d[IReducerKeys.progression_normalized_async]) != null ? _e : getDefaultAsyncWrapperObj()), {
          data: !!((_h = (_g = (_f = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _f[input.progressionId]) == null ? void 0 : _g[IReducerKeys.progression_normalized_async]) == null ? void 0 : _h.data) ? __spreadProps(__spreadValues({}, (_k = (_j = (_i = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _i[input.progressionId]) == null ? void 0 : _j[IReducerKeys.progression_normalized_async]) == null ? void 0 : _k.data), {
            Studies: ___default.uniq([
              ...(_p = (_o = (_n = (_m = (_l = state == null ? void 0 : state[IReducerKeys.progressions_dict]) == null ? void 0 : _l[input.progressionId]) == null ? void 0 : _m[IReducerKeys.progression_normalized_async]) == null ? void 0 : _n.data) == null ? void 0 : _o.Studies) != null ? _p : [],
              input.progressionStageId
            ])
          }) : null
        })
      })
    }),
    [IReducerKeys.progression_stages_dict]: __spreadProps(__spreadValues({}, state == null ? void 0 : state[IReducerKeys.progression_stages_dict]), {
      [input.progressionStageId]: __spreadProps(__spreadValues({}, (_r = (_q = state == null ? void 0 : state[IReducerKeys.progression_stages_dict]) == null ? void 0 : _q[input.progressionStageId]) != null ? _r : defaultProgressionStageReduxData()), {
        [IReducerKeys.progression_stage_async]: __spreadValues({}, asyncData)
      })
    })
  });
};
const afterLoadFeatureActions = (input) => {
  const {
    featureId,
    managementGroup,
    workspaceId,
    experimentStepId,
    gatesTenantName,
    logInitialLoadPLT = false,
    isVNextData = false
  } = input;
  return [
    loadFeatureOperationChecksEpicReducer.actionCreators.load({ featureId }),
    loadMdsProgressionTemplateEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    loadMdsFlightControlEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    loadMdsControlTowerExperienceEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    loadMdsExperimentTemplatesEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    ...showVNextProgressionPage(isVNextData) ? [getLoadWorkspaceAssignmentUnitsEpicReducer().actionCreators.load({ workspaceId })] : [],
    ...showVNextProgressionPage(isVNextData) ? [loadWorkspaceIsolationGroupsEpicReducer.actionCreators.load({ workspaceId })] : [],
    showVNextProgressionPage(isVNextData) ? loadExperimentationGroupTrafficFiltersEpicReducerV2.actionCreators.load({
      workspaceId,
      managementGroup,
      includeArchived: false
    }) : loadMdsExperimentTrafficFiltersEpicReducer.actionCreators.load({
      managementGroup,
      workspaceId
    }),
    loadMdsExperimentExtensionsEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    loadMdsExperimentPermissionEpicReducer.actionCreators.load({ managementGroup, workspaceId }),
    loadMdsDefaultSnapshotProgressionTemplateEpicReducer.actionCreators.load({ workspaceId }),
    loadMdsAnalysisConfigEpicReducer.actionCreators.load({
      managementGroup,
      workspaceId,
      experimentStepId
    }),
    loadProgressionsEpicReducer.actionCreators.load({
      featureId,
      onlyNonArchived: !!EnvironmentService.testUpdatedProgressionsCall(),
      managementGroup,
      workspaceId,
      gatesTenantName,
      logInitialLoadPLT
    }),
    currentFeatureIdActionCreator({ currentFeatureId: featureId })
  ];
};
const getProgressionStageOperationsActions = ({
  state,
  rolloutId,
  progressionDtos,
  logInitialLoadPLT = false
}) => {
  let toggleProgressionStateActions = [];
  let allEnabledProgressionStageIds = [];
  const progressionsToLoad = ProgressionsUtils.getProgressionsToLoad(progressionDtos);
  const mdsSnapshotProgressionTemplates = getMdsSnapShotsProgressionTemplates(state, { rolloutId });
  ___default.forEach(progressionDtos, (progressionDto) => {
    if (!!progressionsToLoad[progressionDto.Id]) {
      toggleProgressionStateActions = [
        ...toggleProgressionStateActions,
        featureDataActions.toggleProgressionState(progressionDto.Id, true)
      ];
      const enabledStages = ProgressionsUtils.getEnabledProgressionStages(
        progressionDto,
        ProgressionsUtils.getMdsProgressionTemplates(mdsSnapshotProgressionTemplates, progressionDto.MdsSnapshot, {})
      );
      allEnabledProgressionStageIds = [
        ...allEnabledProgressionStageIds,
        ...___default.keys(
          ___default.reduce(enabledStages, (existing, curr, key) => !!curr ? __spreadProps(__spreadValues({}, existing), { [key]: curr }) : __spreadValues({}, existing), {})
        )
      ];
    }
  });
  const loadOperationChecksActions = ___default.map(
    allEnabledProgressionStageIds,
    (progressionStageId) => loadOperationChecksEpicReducer.actionCreators.load({
      featureId: rolloutId,
      progressionStageId,
      allProgressionStageIds: logInitialLoadPLT ? allEnabledProgressionStageIds : void 0
    })
  );
  if (EnvironmentService.isUnifiedView && !EnvironmentService.loadSingleStageAlerts()) {
    const loadAlertsActions = ___default.map(
      allEnabledProgressionStageIds,
      (progressionStageId) => loadProgressionStageAlertsEpicReducer.actionCreators.load({
        featureId: rolloutId,
        progressionStageId,
        allProgressionStageIds: logInitialLoadPLT ? allEnabledProgressionStageIds : void 0
      })
    );
    return [...toggleProgressionStateActions, ...loadOperationChecksActions, ...loadAlertsActions];
  } else {
    return [...toggleProgressionStateActions, ...loadOperationChecksActions];
  }
};
const afterLoadProgressionsActions = ({
  state,
  managementGroup,
  workspaceId,
  progressionDtos = [],
  rolloutId,
  gatesTenantName,
  logInitialLoadPLT
}) => {
  const snapshotNames = ___default.uniq(___default.map(progressionDtos, (p) => p.MdsSnapshot));
  const mdsSnapShotsProgressionTemplatesWithAsync = getMdsSnapShotsProgressionTemplatesWithAsync(state, { rolloutId });
  const snapshotsNotCompleted = ___default.filter(
    snapshotNames,
    (snapshot) => {
      var _a;
      return !requestCompleted((_a = mdsSnapShotsProgressionTemplatesWithAsync[snapshot]) == null ? void 0 : _a.status);
    }
  );
  const snapshotsCompleted = ___default.difference(snapshotNames, snapshotsNotCompleted);
  const mdsSnapshotProgressionTemplateActions = ___default.map(snapshotsNotCompleted, (snapshotName) => {
    const progressionDtosWithSnapshot = ___default.filter(
      progressionDtos,
      (progressionDto) => progressionDto.MdsSnapshot === snapshotName
    );
    return loadMdsSnapshotProgressionTemplateEpicReducer.actionCreators.load({
      managementGroup,
      workspaceId,
      snapshotName,
      rolloutId,
      progressionDtos: progressionDtosWithSnapshot,
      logInitialLoadPLT
    });
  });
  const progressionStageOperationActions = ___default.map(snapshotsCompleted, (snapshotName) => {
    const progressionDtosWithSnapshot = ___default.filter(
      progressionDtos,
      (progressionDto) => progressionDto.MdsSnapshot === snapshotName
    );
    return getProgressionStageOperationsActions({
      state,
      rolloutId,
      progressionDtos: progressionDtosWithSnapshot,
      logInitialLoadPLT
    });
  }).flat();
  return [
    loadActiveFeatureGatesEpicReducer.actionCreators.load({ featureId: rolloutId, gatesTenantName }),
    loadFeatureScorecardsEpicReducer.actionCreators.load({ featureId: rolloutId, logInitialLoadPLT }),
    ...mdsSnapshotProgressionTemplateActions,
    ...progressionStageOperationActions,
    // if no progressions, signal completion
    ...!!logInitialLoadPLT && progressionDtos.length === 0 ? [checkProgressionsFullLoad(performance.now())] : []
  ];
};
const reduxActionTypePrefix = "ProgressionActions";
var IReducerKeys = /* @__PURE__ */ ((IReducerKeys2) => {
  IReducerKeys2["features"] = "features";
  IReducerKeys2["featureId"] = "featureId";
  IReducerKeys2["progressions_dict"] = "progressions_dict";
  IReducerKeys2["progression_stages_dict"] = "progression_stages_dict";
  IReducerKeys2["budget_info"] = "budget_info";
  IReducerKeys2["progression_list_async"] = "progression_list_async";
  IReducerKeys2["progression_normalized_async"] = "progression_normalized_async";
  IReducerKeys2["progression_stage_async"] = "progression_stage_async";
  IReducerKeys2["feature_scorecards_async"] = "feature_scorecards_async";
  IReducerKeys2["alerts_batch_async"] = "alerts_batch_async";
  IReducerKeys2["root_feature_async"] = "root_feature_async";
  IReducerKeys2["operation_check_async"] = "operation_check_async";
  IReducerKeys2["active_gates_async"] = "active_gates_async";
  IReducerKeys2["progression_create_async"] = "progression_create_async";
  IReducerKeys2["progression_update_async"] = "progression_update_async";
  IReducerKeys2["progression_migration_async"] = "progression_migration_async";
  IReducerKeys2["feature_initialize_async"] = "feature_initialize_async";
  IReducerKeys2["bulk_edit_progression_stages_async"] = "bulk_edit_progression_stages_async";
  IReducerKeys2["progression_stage_operation_check_async"] = "progression_stage_operation_check_async";
  IReducerKeys2["progression_stage_journals_async"] = "progression_stage_journals_async";
  IReducerKeys2["progression_stage_alerts_async"] = "progression_stage_alerts_async";
  IReducerKeys2["progression_stage_resolve_alerts_async"] = "progression_stage_resolve_alerts_async";
  IReducerKeys2["flights"] = "flights";
  IReducerKeys2["flight_allocation_dict"] = "flight_allocation_dict";
  IReducerKeys2["flight_data_dict"] = "flight_data_dict";
  IReducerKeys2["flight_data_async"] = "flight_data_async";
  IReducerKeys2["feature_auto_trigger_state_async"] = "feature_auto_trigger_state_async";
  IReducerKeys2["update_experiment"] = "update_experiment";
  return IReducerKeys2;
})(IReducerKeys || {});
const defaultReducerState = () => ({
  [
    "features"
    /* features */
  ]: {},
  [
    "progressions_dict"
    /* progressions_dict */
  ]: {},
  [
    "progression_stages_dict"
    /* progression_stages_dict */
  ]: {},
  [
    "flights"
    /* flights */
  ]: {},
  [
    "featureId"
    /* featureId */
  ]: {}
  // FeatureId property was missing, so throwing an error after enabling implicit any
});
const defaultProgressionReduxData = () => ({
  [
    "progression_normalized_async"
    /* progression_normalized_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_update_async"
    /* progression_update_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_migration_async"
    /* progression_migration_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "bulk_edit_progression_stages_async"
    /* bulk_edit_progression_stages_async */
  ]: getDefaultAsyncWrapperObj()
});
const defaultProgressionStageReduxData = () => ({
  [
    "progression_stage_async"
    /* progression_stage_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_stage_operation_check_async"
    /* progression_stage_operation_check_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_stage_journals_async"
    /* progression_stage_journals_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_stage_alerts_async"
    /* progression_stage_alerts_async */
  ]: getDefaultAsyncWrapperObj(),
  [
    "progression_stage_resolve_alerts_async"
    /* progression_stage_resolve_alerts_async */
  ]: getDefaultAsyncWrapperObj()
});
const loadRootFeatureArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_FEATURE`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "root_feature_async"
    /* root_feature_async */
  ],
  loadResource: (payload) => featureResource.loadRootFeatureV2(payload.featureId),
  onLoaded: (response) => {
    var _a;
    if ((response == null ? void 0 : response.isSuccessful()) && ((_a = response == null ? void 0 : response.completeResponse) == null ? void 0 : _a.getResponseHeader(AdapterForwardedFromHeader)) === AdapterForwardedFromValues.vNext) {
      var data = response.getSuccessData();
      data.IsVNextData = true;
      return {
        isSuccessful: response.isSuccessful(),
        data
      };
    }
  },
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    var _a, _b, _c, _d, _e;
    const { dontLoadExtraResources = false } = inputPayload;
    if (inputPayload.featureId !== outputPayload.Id && !!outputPayload.Id) {
      NavigationService.navigateTo(`/a/feature/${outputPayload.Id}`);
    }
    return [
      /**Below line is needed to make sure that if the Id provided
       *  in the URL is a progression Stage ID, we endup saving the
       * correct featureId in Redux */
      ...inputPayload.featureId !== outputPayload.Id ? [
        loadRootFeatureEpicReducer.actionCreators.loaded(
          __spreadProps(__spreadValues({}, inputPayload), { featureId: outputPayload.Id }),
          getCompletedAsyncWrapperObj(outputPayload)
        )
      ] : [],
      ...!dontLoadExtraResources ? afterLoadFeatureActions({
        // NOTE: Feature Id in the response is the correct featureId, The request id could be a progression stage Id
        featureId: outputPayload.Id,
        managementGroup: outputPayload.ManagementGroup,
        workspaceId: outputPayload.WorkspaceId,
        isVNextData: outputPayload.IsVNextData,
        gatesTenantName: (_b = (_a = outputPayload == null ? void 0 : outputPayload["GateSetMetadata"]) == null ? void 0 : _a.TenantName) != null ? _b : getTenantFromManagementGroup(outputPayload.ManagementGroup),
        experimentStepId: (_e = (_d = (_c = outputPayload.Phases) == null ? void 0 : _c[0]) == null ? void 0 : _d.StepIds) == null ? void 0 : _e[0],
        logInitialLoadPLT: !inputPayload.dontLogInitialPLT
      }) : [],
      ...EnvironmentService.enableAutoTriggerToggle() ? [
        loadFeatureAutoTriggerStateEpicReducer.actionCreators.load({
          workspaceId: outputPayload.WorkspaceId,
          featureId: outputPayload.Id
        })
      ] : [],
      loadRootFeatureEpicReducer$1.actionCreators.loaded(inputPayload, getCompletedAsyncWrapperObj(outputPayload))
    ];
  }
};
const loadRootFeatureEpicReducer = loadResourcesUtils(loadRootFeatureArgs);
const loadFeatureOperationChecksArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_FEATURE_OPERATION_CHECKS`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "operation_check_async"
    /* operation_check_async */
  ],
  loadResource: (payload) => experimentResource.getOperationChecksForExperiment(payload.featureId),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadFeatureOperationChecksEpicReducer = loadResourcesUtils(loadFeatureOperationChecksArgs);
const loadActiveFeatureGatesArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_ACTIVE_FEATURE_GATES`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "active_gates_async"
    /* active_gates_async */
  ],
  loadResource: ({ gatesTenantName, featureId, aggregateParents = false }) => {
    return GatingResource.getActiveGatesInternalV2(gatesTenantName, featureId, aggregateParents);
  },
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload) => {
    for (var key in outputPayload) {
      if (key.endsWith("-0")) {
        return [loadActiveFeatureGatesEpicReducer.actionCreators.load(__spreadProps(__spreadValues({}, inputPayload), { aggregateParents: true }))];
      }
    }
    return [overrideActions.updateGates(getCompletedAsyncWrapperObj(outputPayload))];
  }
};
const loadActiveFeatureGatesEpicReducer = loadResourcesUtils(loadActiveFeatureGatesArgs);
const loadBudgetInfoArgs = {
  actionPrefix: `${reduxActionTypePrefix}/LOAD_BUDGET_INFO`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "budget_info",
    inputPayload.templateName
  ],
  loadResource: (payload) => BudgetResources.calculateTrafficUsage(payload.request),
  onCompleteSuccess: (result) => {
    return result;
  }
};
const loadBudgetInfoEpicReducer = loadResourcesUtils(loadBudgetInfoArgs);
const LOAD_PROGRESSIONS_ACTION_PREFIX = "LOAD_PROGRESSIONS";
const loadProgressionsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_PROGRESSIONS_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "Dummy"
  ],
  loadResource: ({ featureId, onlyArchivedProgressions = false, onlyNonArchived = false }) => FeatureResources.loadProgressionsRestResult(featureId, onlyArchivedProgressions, onlyNonArchived),
  onCompleteSuccess: (result) => {
    return nomalizeProgressionResult(result);
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const { managementGroup, workspaceId, featureId: rolloutId, gatesTenantName, logInitialLoadPLT } = inputPayload;
    const progressionDtos = ProgressionsUtils.getProgressionDtos(outputPayload);
    return afterLoadProgressionsActions({
      state,
      managementGroup,
      workspaceId,
      rolloutId,
      progressionDtos,
      gatesTenantName,
      logInitialLoadPLT
    });
  }
};
const loadProgressionsEpicReducer = loadResourcesUtils(loadProgressionsArg);
const LOAD_PROGRESSION_STAGE_OPERATION_CHECK = "LOAD_PROGRESSION_STAGE_OPERATION_CHECK";
const loadOperationChecksArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_PROGRESSION_STAGE_OPERATION_CHECK}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "progression_stage_operation_check_async"
    /* progression_stage_operation_check_async */
  ],
  loadResource: (payload) => experimentResource.getOperationChecksForExperiment(payload.progressionStageId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ progressionStageId, allProgressionStageIds, featureId }, outputPayload, state) => {
    const restStageStatuses = ___default.map(
      ___default.filter(allProgressionStageIds, (stageId) => stageId !== progressionStageId),
      (stageId) => getProgressionStageOperationsAsync(state, { progressionStageId: stageId }).status
    );
    const templatesAsync = getMdsSnapShotsProgressionTemplatesWithAsync(state, { rolloutId: featureId });
    const templateStatuses = ___default.map(templatesAsync, (asyncData) => asyncData == null ? void 0 : asyncData.status);
    if (!!allProgressionStageIds && allRequestsHaveCompleted(restStageStatuses) && allRequestsHaveCompleted(templateStatuses)) {
      return [checkProgressionsFullLoad(performance.now())];
    }
    return [];
  }
};
const loadOperationChecksEpicReducer = loadResourcesUtils(loadOperationChecksArg);
const LOAD_PROGRESSION_STAGE_ALERTS = "LOAD_PROGRESSION_STAGE_ALERTS";
const loadProgressionStageAlertsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_PROGRESSION_STAGE_ALERTS}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "progression_stage_alerts_async"
    /* progression_stage_alerts_async */
  ],
  loadResource: (payload, state) => {
    const workspaceId = getWorkspaceId(state, { rolloutId: payload.featureId });
    return AlertResources.getActiveQualityAlertsVNextV2(payload.progressionStageId, workspaceId);
  },
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ progressionStageId, allProgressionStageIds, featureId }, outputPayload, state) => {
    if (!EnvironmentService.loadSingleStageAlerts() && EnvironmentService.isUnifiedView) {
      const restStageStatuses = ___default.map(
        ___default.filter(allProgressionStageIds, (stageId) => stageId !== progressionStageId),
        (stageId) => getProgressionStageAlertsAsync(state, { progressionStageId: stageId }).status
      );
      const templatesAsync = getMdsSnapShotsProgressionTemplatesWithAsync(state, { rolloutId: featureId });
      const templateStatuses = ___default.map(templatesAsync, (asyncData) => asyncData == null ? void 0 : asyncData.status);
      if (!!allProgressionStageIds && allRequestsHaveCompleted(restStageStatuses) && allRequestsHaveCompleted(templateStatuses)) {
        return [checkAlertsFullLoad(performance.now())];
      }
    }
    return [];
  }
};
const loadProgressionStageAlertsEpicReducer = loadResourcesUtils(loadProgressionStageAlertsArg);
const RESOLVE_PROGRESSION_STAGE_ALERTS = "RESOLVE_PROGRESSION_STAGE_ALERTS";
const resolveProgressionStageAlertsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${RESOLVE_PROGRESSION_STAGE_ALERTS}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "progression_stage_resolve_alerts_async"
    /* progression_stage_resolve_alerts_async */
  ],
  loadResource: ({ alertEngageData, featureId }, state) => {
    const request = AlertUtils.createResolveAlertRequestDTO(alertEngageData);
    const action = !!alertEngageData.alertEngagement ? alertEngageData.alertEngagement.action || "Resolve" : "Resolve";
    const workspaceId = getWorkspaceId(state, { rolloutId: featureId });
    return AlertResources.resolveQualityAlertsVNextV2(request, action, workspaceId);
  },
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => [
    loadProgressionStageAlertsEpicReducer.actionCreators.load(inputPayload),
    resolveProgressionStageAlertsEpicReducer.actionCreators.reset(inputPayload)
  ]
};
const resolveProgressionStageAlertsEpicReducer = loadResourcesUtils(resolveProgressionStageAlertsArg);
const UPDATE_EXPERIMENT = "UPDATE_EXPERIMENT";
const updateExperimentArg = {
  actionPrefix: `${reduxActionTypePrefix}/${UPDATE_EXPERIMENT}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "update_experiment"
    /* update_experiment */
  ],
  loadResource: (payload) => {
    return experimentResource.updateExperiment(payload.progressionStageId, payload.update);
  },
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: (inputPayload) => [loadProgressionStageAlertsEpicReducer.actionCreators.load(inputPayload)]
};
const updateExperimentEpicReducer = loadResourcesUtils(updateExperimentArg);
const LOAD_PROGRESSION_STAGE_JOURNALS = "LOAD_PROGRESSION_STAGE_JOURNALS";
const loadProgressionStageJournalsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_PROGRESSION_STAGE_JOURNALS}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "progression_stage_journals_async"
    /* progression_stage_journals_async */
  ],
  loadResource: (payload) => experimentResource.getExperimentJournals(payload.progressionStageId),
  onCompleteSuccess: (result) => result
};
const loadProgressionStageJournalsEpicReducer = loadResourcesUtils(loadProgressionStageJournalsArg);
const LOAD_FEATURE_SCORECARDS = "LOAD_FEATURE_SCORECARDS";
const loadFeatureScorecardsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_FEATURE_SCORECARDS}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "feature_scorecards_async"
    /* feature_scorecards_async */
  ],
  loadResource: (payload) => experimentResource.getScorecardsForFeature(payload.featureId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ logInitialLoadPLT = false }) => {
    return logInitialLoadPLT ? [checkProgressionsScorecardsFullLoad(performance.now())] : [];
  }
};
const loadFeatureScorecardsEpicReducer = loadResourcesUtils(loadFeatureScorecardsArg);
const LOAD_FLIGHT_DATA = "LOAD_FLIGHT_DATA";
const loadFlightDataArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_FLIGHT_DATA}`,
  reduxKeyNested: (inputPayload) => [
    "flights",
    inputPayload.flight,
    "flight_data_dict",
    inputPayload.managementGroup,
    "flight_data_async"
    /* flight_data_async */
  ],
  loadResource: ({ flight, managementGroup, workspaceId }) => featureResource.getFlight(flight, managementGroup, workspaceId),
  onCompleteSuccess: (result) => result
};
const loadFlightDataEpicReducer = loadResourcesUtils(loadFlightDataArg);
const LOAD_SINGLE_PROGRESSION_ACTION_PREFIX = "LOAD_SINGLE_PROGRESSION_ACTION_PREFIX";
const loadSingleProgressionArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "Dummy"
  ],
  loadResource: (payload) => FeatureResources.loadProgressionRestResult(payload.featureId, payload.progressionId),
  onCompleteSuccess: (result) => {
    return normalizeSingleProgressionResult(result);
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const { managementGroup, workspaceId, featureId: rolloutId, gatesTenantName } = inputPayload;
    const progressionDtos = ProgressionsUtils.getProgressionDtos(__spreadProps(__spreadValues({}, outputPayload), {
      resultProgressionIds: [outputPayload.resultProgressionId]
    }));
    return afterLoadProgressionsActions({ state, managementGroup, workspaceId, rolloutId, progressionDtos, gatesTenantName });
  }
};
const loadSingleProgressionEpicReducer = loadResourcesUtils(loadSingleProgressionArg);
const LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX = "LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX";
const loadSingleProgressionStageArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "progression_stages_dict",
    inputPayload.progressionStageId,
    "progression_stage_async",
    "Dummy"
  ],
  loadResource: (payload) => experimentReadV2Resource.getExperiment(payload.progressionStageId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ progressionStageId }, outputPayload, state) => {
    const { FeatureRolloutMetadata: { RootExperimentId: featureId = "" } = {} } = outputPayload;
    const gatesTenantName = getRootFeatureGatesTenantName(state, { rolloutId: featureId });
    return [
      loadActiveFeatureGatesEpicReducer.actionCreators.load({ featureId, gatesTenantName }),
      loadFeatureScorecardsEpicReducer.actionCreators.load({ featureId }),
      loadOperationChecksEpicReducer.actionCreators.load({ featureId, progressionStageId }),
      ...EnvironmentService.loadSingleStageAlerts() || EnvironmentService.isUnifiedView ? [loadProgressionStageAlertsEpicReducer.actionCreators.load({ featureId, progressionStageId })] : []
    ];
  }
};
const loadSingleProgressionStageEpicReducer = loadResourcesUtils(loadSingleProgressionStageArg);
const featureInitializeArg = {
  actionPrefix: `${reduxActionTypePrefix}/FEATURE_INITIALIZE`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "feature_initialize_async"
    /* feature_initialize_async */
  ],
  loadResource: (payload) => featureResource.initializeRootFeatureRestResult(payload.featureId),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    var _a, _b, _c, _d, _e;
    return [
      /** If the Load for feature data hasn't happened yet, then load it, otherwise update the existing data */
      loadRootFeatureEpicReducer.actionCreators.loaded(inputPayload, getCompletedAsyncWrapperObj(outputPayload)),
      ...afterLoadFeatureActions({
        featureId: outputPayload.Id,
        managementGroup: outputPayload.ManagementGroup,
        workspaceId: outputPayload.WorkspaceId,
        isVNextData: !!outputPayload.IsVNextData,
        gatesTenantName: (_b = (_a = outputPayload == null ? void 0 : outputPayload["GateSetMetadata"]) == null ? void 0 : _a.TenantName) != null ? _b : getTenantFromManagementGroup(outputPayload.ManagementGroup),
        experimentStepId: (_e = (_d = (_c = outputPayload.Phases) == null ? void 0 : _c[0]) == null ? void 0 : _d.StepIds) == null ? void 0 : _e[0]
      })
    ];
  }
};
const featureInitializeEpicReducer = loadResourcesUtils(featureInitializeArg);
const createProgressionsArg = {
  actionPrefix: `${reduxActionTypePrefix}/CREATE_PROGRESSION`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "progression_create_async"
    /* progression_create_async */
  ],
  loadResource: (payload) => featureResource.createProgressionRestResult(payload.featureId, payload.postData),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    inputPayload.context.setProgressionSelectionContext({ isProgressionSelectionVisible: false });
    const gatesTenantName = getRootFeatureGatesTenantName(state, { rolloutId: inputPayload.featureId });
    return [
      loadSingleProgressionEpicReducer.actionCreators.load({
        featureId: inputPayload.featureId,
        managementGroup: inputPayload.managementGroup,
        workspaceId: inputPayload.workspaceId,
        progressionId: outputPayload,
        gatesTenantName
      })
    ];
  }
};
const createProgressionEpicReducer = loadResourcesUtils(createProgressionsArg);
const UPDATE_PROGRESSION_ACTION_PREFIX = "UPDATE_PROGRESSION";
const updateProgressionsArg = {
  actionPrefix: `${reduxActionTypePrefix}/${UPDATE_PROGRESSION_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "progressions_dict",
    inputPayload.progressionId,
    "progression_update_async"
    /* progression_update_async */
  ],
  loadResource: (payload) => featureResource.updateProgression(payload.featureId, payload.progressionId, payload.postData),
  onCompleteSuccess: (result) => {
    return result;
  },
  afterActionsOnSuccess: (inputPayload, outputPayload, state) => {
    const gatesTenantName = getRootFeatureGatesTenantName(state, { rolloutId: inputPayload.featureId });
    return [
      loadSingleProgressionEpicReducer.actionCreators.load({
        featureId: inputPayload.featureId,
        managementGroup: inputPayload.managementGroup,
        workspaceId: inputPayload.workspaceId,
        progressionId: inputPayload.progressionId,
        gatesTenantName
      })
    ];
  }
};
const updateProgressionEpicReducer = loadResourcesUtils(updateProgressionsArg);
const MIGRATE_PROGRESSION_ACTION_PREFIX = "MIGRATE_PROGRESSION";
const migrateProgressionArg = {
  actionPrefix: `${reduxActionTypePrefix}/${MIGRATE_PROGRESSION_ACTION_PREFIX}`,
  reduxKeyNested: ({ progressionId }) => [
    "progressions_dict",
    progressionId,
    "progression_migration_async"
    /* progression_migration_async */
  ],
  loadResource: ({ featureId, progressionId }) => featureResource.migrateProgressionToConfigProvider(featureId, progressionId),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ featureId, progressionId }, outputPayload, state) => {
    const workspaceId = getWorkspaceId(state, { rolloutId: progressionId });
    const managementGroup = getManagementGroup(state, { rolloutId: featureId });
    const gatesTenantName = getRootFeatureGatesTenantName(state, { rolloutId: featureId });
    return [
      loadSingleProgressionEpicReducer.actionCreators.loaded(
        { featureId, progressionId, workspaceId, managementGroup, gatesTenantName },
        getCompletedAsyncWrapperObj(normalizeSingleProgressionResult(outputPayload))
      )
    ];
  }
};
const migrateProgressionEpicReducer = loadResourcesUtils(migrateProgressionArg);
const LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX = "LOAD_FEATURE_AUTO_TRIGGER_STATE";
const loadFeatureAutoTriggerStateArg = {
  actionPrefix: `${reduxActionTypePrefix}/${LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX}`,
  reduxKeyNested: (inputPayload) => [
    "features",
    inputPayload.featureId,
    "feature_auto_trigger_state_async"
    /* feature_auto_trigger_state_async */
  ],
  loadResource: (payload) => {
    const { workspaceId, featureId } = payload;
    return AnalysisResourceV2.getFeatureAutoTriggeringState(workspaceId, featureId);
  },
  onCompleteSuccess: (result) => {
    return result;
  },
  onLoaded: (response) => {
    if (!!response && response.statusCode == 404) {
      const featureAutoTriggerStateResult = {
        value: false,
        error: {
          code: "404",
          message: "Not Found"
        }
      };
      return {
        isSuccessful: true,
        data: featureAutoTriggerStateResult
      };
    }
  }
};
const loadFeatureAutoTriggerStateEpicReducer = loadResourcesUtils(loadFeatureAutoTriggerStateArg);
const BULK_EDIT_PROGRESSION_ACTION_PREFIX = "BULK_EDIT_PROGRESSION";
const bulkEditProgressionArg = {
  actionPrefix: `${reduxActionTypePrefix}/${BULK_EDIT_PROGRESSION_ACTION_PREFIX}`,
  reduxKeyNested: ({ progressionId }) => [
    "progressions_dict",
    progressionId,
    "bulk_edit_progression_stages_async"
    /* bulk_edit_progression_stages_async */
  ],
  loadResource: ({ featureId, progressionId, progressionStagesBackend }) => featureResource.bulkEditStages(featureId, progressionId, progressionStagesBackend),
  onCompleteSuccess: (result) => result,
  afterActionsOnSuccess: ({ featureId, progressionId }, outputPayload, state) => {
    const workspaceId = getWorkspaceId(state, { rolloutId: progressionId });
    const managementGroup = getManagementGroup(state, { rolloutId: featureId });
    const gatesTenantName = getRootFeatureGatesTenantName(state, { rolloutId: featureId });
    return [
      loadSingleProgressionEpicReducer.actionCreators.load({
        featureId,
        progressionId,
        workspaceId,
        managementGroup,
        gatesTenantName
      }),
      bulkEditProgressionEpicReducer.actionCreators.reset({
        featureId,
        progressionId,
        progressionStagesBackend: []
      })
    ];
  }
};
const bulkEditProgressionEpicReducer = loadResourcesUtils(bulkEditProgressionArg);
const reducer = (state = defaultReducerState(), action) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
  state = loadRootFeatureEpicReducer.reduxChange(state, action);
  state = loadFeatureOperationChecksEpicReducer.reduxChange(state, action);
  state = loadActiveFeatureGatesEpicReducer.reduxChange(state, action);
  state = loadBudgetInfoEpicReducer.reduxChange(state, action);
  state = createProgressionEpicReducer.reduxChange(state, action);
  state = updateProgressionEpicReducer.reduxChange(state, action);
  state = loadOperationChecksEpicReducer.reduxChange(state, action);
  state = loadProgressionStageJournalsEpicReducer.reduxChange(state, action);
  state = loadFeatureScorecardsEpicReducer.reduxChange(state, action);
  state = featureInitializeEpicReducer.reduxChange(state, action);
  state = loadFlightDataEpicReducer.reduxChange(state, action);
  state = migrateProgressionEpicReducer.reduxChange(state, action);
  state = loadProgressionStageAlertsEpicReducer.reduxChange(state, action);
  state = resolveProgressionStageAlertsEpicReducer.reduxChange(state, action);
  state = bulkEditProgressionEpicReducer.reduxChange(state, action);
  state = loadFeatureAutoTriggerStateEpicReducer.reduxChange(state, action);
  if (action.type === `${reduxActionTypePrefix}/${LOAD_PROGRESSIONS_ACTION_PREFIX}/LOADING`) {
    state = __spreadProps(__spreadValues({}, state), {
      features: __spreadValues(__spreadValues({}, state.features), setFeatureProgressionsLoading(state, action.payload))
    });
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_PROGRESSIONS_ACTION_PREFIX}/LOADED`) {
    action = action;
    state = __spreadProps(__spreadValues({}, state), {
      [
        "features"
        /* features */
      ]: __spreadValues(__spreadValues({}, state.features), setFeatureInReduxWhenProgressionsLoaded(
        state,
        action.payload,
        (_c = (_b = (_a = action.outputPayloadAsync) == null ? void 0 : _a.data) == null ? void 0 : _b.resultProgressionIds) != null ? _c : [],
        action.outputPayloadAsync
      )),
      [
        "progressions_dict"
        /* progressions_dict */
      ]: __spreadValues(__spreadValues({}, state.progressions_dict), setProgressionsInReduxWhenProgressionsLoaded(
        state,
        (_f = (_e = (_d = action.outputPayloadAsync) == null ? void 0 : _d.data) == null ? void 0 : _e.progressions) != null ? _f : {},
        action.outputPayloadAsync
      )),
      [
        "progression_stages_dict"
        /* progression_stages_dict */
      ]: __spreadValues(__spreadValues({}, state.progression_stages_dict), setProgressionStagesInReduxWhenProgressionsLoaded(
        state,
        (_i = (_h = (_g = action.outputPayloadAsync) == null ? void 0 : _g.data) == null ? void 0 : _h.progressionStages) != null ? _i : {},
        action.outputPayloadAsync
      ))
    });
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_ACTION_PREFIX}/LOADING`) {
    action = action;
    state = __spreadProps(__spreadValues({}, state), {
      [
        "features"
        /* features */
      ]: __spreadValues({}, setProgressionInReduxWhenSingleProgressionLoading(state, action.payload)),
      [
        "progressions_dict"
        /* progressions_dict */
      ]: __spreadValues({}, setProgressionDictInReduxWhenSingleProgressionLoading(state, action.payload))
    });
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_ACTION_PREFIX}/LOADED`) {
    action = action;
    state = __spreadProps(__spreadValues({}, state), {
      [
        "features"
        /* features */
      ]: __spreadValues(__spreadValues({}, state.features), setFeatureInReduxWhenSingleProgressionLoaded(
        state,
        action.payload,
        (_l = (_k = (_j = action.outputPayloadAsync) == null ? void 0 : _j.data) == null ? void 0 : _k.resultProgressionId) != null ? _l : "",
        action.outputPayloadAsync
      )),
      [
        "progressions_dict"
        /* progressions_dict */
      ]: __spreadValues(__spreadValues({}, state.progressions_dict), setProgressionsInReduxWhenProgressionsLoaded(
        state,
        (_o = (_n = (_m = action.outputPayloadAsync) == null ? void 0 : _m.data) == null ? void 0 : _n.progressions) != null ? _o : {},
        action.outputPayloadAsync
      )),
      [
        "progression_stages_dict"
        /* progression_stages_dict */
      ]: __spreadValues(__spreadValues({}, state.progression_stages_dict), setProgressionStagesInReduxWhenProgressionsLoaded(
        state,
        (_r = (_q = (_p = action.outputPayloadAsync) == null ? void 0 : _p.data) == null ? void 0 : _q.progressionStages) != null ? _r : {},
        action.outputPayloadAsync
      ))
    });
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX}/LOADING`) {
    action = action;
    state = __spreadValues({}, setSingleProgressionStageInReduxLoading(state, action.payload));
  }
  if (action.type === `${reduxActionTypePrefix}/${LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX}/LOADED`) {
    action = action;
    state = __spreadValues({}, setSingleProgressionStageInReduxLoaded(state, action.payload, action.outputPayloadAsync));
  }
  return state;
};
const epics = combineEpics(
  loadRootFeatureEpicReducer.epic,
  loadFeatureOperationChecksEpicReducer.epic,
  loadActiveFeatureGatesEpicReducer.epic,
  loadBudgetInfoEpicReducer.epic,
  loadProgressionsEpicReducer.epic,
  createProgressionEpicReducer.epic,
  updateProgressionEpicReducer.epic,
  loadSingleProgressionEpicReducer.epic,
  loadSingleProgressionStageEpicReducer.epic,
  loadOperationChecksEpicReducer.epic,
  loadProgressionStageJournalsEpicReducer.epic,
  loadFeatureScorecardsEpicReducer.epic,
  featureInitializeEpicReducer.epic,
  loadFlightDataEpicReducer.epic,
  migrateProgressionEpicReducer.epic,
  loadProgressionStageAlertsEpicReducer.epic,
  resolveProgressionStageAlertsEpicReducer.epic,
  bulkEditProgressionEpicReducer.epic,
  loadFeatureAutoTriggerStateEpicReducer.epic,
  updateExperimentEpicReducer.epic
);
const progressionCloneGroupsUtilInner = (input) => {
  var _a, _b, _c;
  const {
    managementGroup,
    defaultSnapshot: {
      data: { DefaultSnapshot: defaultSnapshot }
    },
    parsedFeature: { featureMetadata, flightList },
    progressionsAsync,
    progressionStagesAsync,
    mdsFiltersAsync: { data: mdsFilters },
    mdsProgressionTemplatesAsync: {
      data: { ProgressionTemplates: mdsProgressionTemplates }
    },
    mdsExperimentTemplatesAsync: { data: mdsExperimentTemplates },
    mdsControlTowerExperienceAsync: { data: mdsControlTowerExperience },
    mdsSnapshotTemplates,
    activeFeatureGatesAsync,
    featureScorecardsAsync: { data: featureScorecards },
    onlyArchivedProgressions = false
  } = input;
  const progressionValues = ___default.values(progressionsAsync);
  const progressionsPreInput = ___default.map(progressionValues, (p) => {
    var _a2;
    return (_a2 = p[IReducerKeys.progression_normalized_async]) == null ? void 0 : _a2.data;
  });
  let progressionsInput = ___default.cloneDeep(progressionsPreInput);
  const progressionStagesArr = ___default.map(progressionsPreInput, (p) => {
    return ___default.map(p.Studies, (study) => progressionStagesAsync[study][IReducerKeys.progression_stage_async].data);
  });
  ___default.forEach(progressionStagesArr, (stages, index) => progressionsInput[index].Studies = stages);
  let progressionDtos = [];
  if (progressionsInput.length > 0) {
    progressionDtos = progressionsInput.filter((progressionDto) => !progressionDto.IsArchived || !progressionDto.IsHidden);
  }
  if (progressionDtos.length > 1) {
    progressionDtos = CommonUtilsInstance.sortByDateString(
      progressionDtos,
      CommonUtilsInstance.getPropName(progressionDtos[0], progressionDtos[0].Created)
    );
  }
  const progressionTemplatesBySnapshot = {};
  for (let i = 0; i < progressionDtos.length; ++i) {
    const p = progressionDtos[i];
    if (p.MdsSnapshot && p.MdsSnapshot !== defaultSnapshot) {
      if (!progressionTemplatesBySnapshot[p.MdsSnapshot] && ((_a = mdsSnapshotTemplates[p.MdsSnapshot]) == null ? void 0 : _a[IReducerKeys$1.mds_progression_templates_async].status) === AsyncRequestStatus.Completed) {
        progressionTemplatesBySnapshot[p.MdsSnapshot] = mdsSnapshotTemplates[p.MdsSnapshot][IReducerKeys$1.mds_progression_templates_async].data;
        progressionTemplatesBySnapshot[p.MdsSnapshot] = MasterDataUtilInstance.normalizeProgressionTemplatesTrafficFilters(
          progressionTemplatesBySnapshot[p.MdsSnapshot],
          mdsFilters
        );
      }
    }
  }
  const progressions = featureUtilsV2Instance.parseProgressions(
    progressionDtos,
    mdsFilters,
    flightList,
    progressionTemplatesBySnapshot,
    mdsProgressionTemplates,
    onlyArchivedProgressions
  );
  const mdsSnapshotToProgressionTemplateMap = {};
  ___default.forEach(progressions, (p) => {
    const snapshotTemplates = progressionTemplatesBySnapshot[p.mdsSnapshot];
    if (p.mdsSnapshot && !!snapshotTemplates && !!snapshotTemplates.ProgressionTemplates && !!snapshotTemplates.ProgressionTemplates[p.templateName]) {
      p.progressionSelection = MasterDataUtilInstance.getProgressionSelectionForProgression(
        mdsFilters,
        snapshotTemplates.ProgressionTemplates[p.templateName],
        mdsExperimentTemplates,
        mdsControlTowerExperience,
        p
      );
      mdsSnapshotToProgressionTemplateMap[p.mdsSnapshot] = ___default.cloneDeep(snapshotTemplates);
    } else {
      p.progressionSelection = MasterDataUtilInstance.getProgressionSelectionForProgression(
        mdsFilters,
        mdsProgressionTemplates[p.templateName],
        mdsExperimentTemplates,
        mdsControlTowerExperience,
        p
      );
    }
    ___default.forEach(p.filteredProgressionStages, (target) => {
      updateTargetTrafficFilterWarning(p.progressionFilters, target.initialTrafficFilters);
    });
  });
  let progressionCloneGroups = constructProgressionCloneGroups(progressions);
  const tenantName = getTenantFromManagementGroup(managementGroup);
  const gatesTenantName = (_c = (_b = featureMetadata == null ? void 0 : featureMetadata.gatesMetadata) == null ? void 0 : _b.TenantName) != null ? _c : tenantName;
  let pendingApprovalRequests = [];
  updateActiveProgressionOperationChecks(progressionCloneGroups, progressionStagesAsync);
  updateGates(featureMetadata.id, gatesTenantName, progressionCloneGroups, activeFeatureGatesAsync, pendingApprovalRequests);
  updateExperimentJournals(progressionCloneGroups, progressionStagesAsync);
  updateScorecards(progressionCloneGroups, featureScorecards != null ? featureScorecards : {});
  const archivedProgressionCloneGroups = ___default.reduce(
    progressionCloneGroups,
    (existing, curr, key) => ___default.every(curr, (val) => val.isArchived) ? __spreadProps(__spreadValues({}, existing), { [key]: curr }) : __spreadValues({}, existing),
    {}
  );
  progressionCloneGroups = ___default.reduce(
    progressionCloneGroups,
    (existing, curr, key) => ___default.some(curr, (val) => !val.isArchived) ? __spreadProps(__spreadValues({}, existing), { [key]: curr }) : __spreadValues({}, existing),
    {}
  );
  return {
    archivedProgressionCloneGroupsV2: archivedProgressionCloneGroups,
    mdsSnapshotProgressionTemplatesMap: mdsSnapshotToProgressionTemplateMap,
    progressionCloneGroups,
    pendingApprovalRequests
  };
};
const updateTargetTrafficFilterWarning = (progressionTrafficFilters, initialTargetTrafficFilters) => {
  const keys = Object.keys(progressionTrafficFilters.trafficFilters);
  ___default.forEach(keys, (key) => {
    if (!initialTargetTrafficFilters.trafficFilters[key]) {
      initialTargetTrafficFilters.trafficFilters[key] = ___default.cloneDeep(progressionTrafficFilters.trafficFilters[key]);
      TrafficFilterUtilInstance.setCurrentValueEmpty(initialTargetTrafficFilters.trafficFilters[key]);
    }
    if (!TrafficFilterUtilInstance.areSelectedValuesEqual(
      progressionTrafficFilters.trafficFilters[key],
      initialTargetTrafficFilters.trafficFilters[key]
    )) {
      initialTargetTrafficFilters.trafficFilters[key].warning = "The above selected value override the progression level value";
    } else {
      initialTargetTrafficFilters.trafficFilters[key].warning = null;
    }
  });
};
const updateActiveProgressionOperationChecks = (progressionCloneGroups, progressionStagesAsync) => {
  ___default.forOwn(progressionCloneGroups, (progressions) => {
    ___default.forEach(progressions, (progression, index) => {
      const enabledStages = ProgressionUtilsInstance.getEnabledProgressionStages(progression);
      ___default.forEach(progression.filteredProgressionStages, (target, i) => {
        var _a, _b;
        const { key, index: index2 } = findProgressionInProgressionCloneGroups(progression.id, progressionCloneGroups);
        if (!!key && index2 > -1) {
          const progressionTarget = progressionCloneGroups[key][index2].filteredProgressionStages[i];
          if (enabledStages[target.id]) {
            const operationAsync = (_b = (_a = progressionStagesAsync == null ? void 0 : progressionStagesAsync[target.id]) == null ? void 0 : _a[IReducerKeys.progression_stage_operation_check_async]) != null ? _b : getDefaultAsyncWrapperObj();
            const isCallSuccessful = !!!(operationAsync == null ? void 0 : operationAsync.error);
            if (operationAsync.status === AsyncRequestStatus.Completed || operationAsync.status === AsyncRequestStatus.Failed) {
              progressionTarget.operationCheck = operationCheckUtils.parseOperationCheckResponse(
                {
                  operationChecks: isCallSuccessful ? operationAsync == null ? void 0 : operationAsync.data : null,
                  error: !isCallSuccessful ? "Error in fetching operation checks" : null,
                  errorDetails: !isCallSuccessful ? `The result wasn't successful (${operationAsync == null ? void 0 : operationAsync.error})-${operationAsync == null ? void 0 : operationAsync.errorContext}` : null
                },
                progressionTarget.operationCheck
              );
            } else {
              progressionTarget.operationCheck = { status: operationAsync.status };
            }
          } else {
            progressionTarget.operationCheck = {
              status: AsyncRequestStatus.Completed
            };
          }
        }
      });
    });
  });
};
const updateExperimentJournals = (progressionCloneGroups, progressionStagesAsync) => {
  ___default.forOwn(progressionCloneGroups, (progressions) => {
    ___default.forEach(progressions, (progression, index) => {
      ___default.forEach(progression.filteredProgressionStages, (target, i) => {
        var _a, _b;
        const { key, index: index2 } = findProgressionInProgressionCloneGroups(progression.id, progressionCloneGroups);
        if (!!key && index2 > -1) {
          let progressionStage = progressionCloneGroups[key][index2].filteredProgressionStages[i];
          const journalEntriesAsync = (_a = progressionStagesAsync[progressionStage.id]) == null ? void 0 : _a[IReducerKeys.progression_stage_journals_async];
          progressionStage.journals.status = journalEntriesAsync == null ? void 0 : journalEntriesAsync.status;
          progressionStage.journals = progressionStageUtils.parseExperimentJournalResponse(
            {
              progressionId: progression.id,
              progressionTargetIndex: i,
              oldIteratedStage: false,
              journalEntries: (_b = journalEntriesAsync == null ? void 0 : journalEntriesAsync.data) != null ? _b : []
            },
            progressionStage.journals
          );
        }
      });
    });
  });
};
const updateScorecards = (progressionCloneGroups, scorecardData) => {
  let scorecards = {};
  ___default.forOwn(scorecardData, (value, key) => {
    scorecards[key] = {
      analysisEnd: !!value.AnalysisEnd ? new Date(value.AnalysisEnd) : null,
      analysisLink: value.AnalysisLink,
      hasAnalysis: value.HasAnalysis,
      experimentId: value.ExperimentId,
      scorecardLink: value.ScorecardLink,
      stepId: value.StepId
    };
  });
  ___default.forOwn(progressionCloneGroups, (progressions, originalId) => {
    ___default.forEach(progressions, (p) => {
      ___default.forEach([...p.filteredProgressionStages, ...p.allProgressionStages], (t) => {
        ___default.forEach(t.stages, (s) => {
          let stageScorecards = [];
          ___default.forEach(s.stepIds, (stepId) => {
            if (stepId in scorecards) {
              stageScorecards.push(scorecards[stepId]);
            }
          });
          s.scorecards = stageScorecards.sort((s1, s2) => {
            let t1 = !!s1.analysisEnd ? s1.analysisEnd.getTime() : 0;
            let t2 = !!s2.analysisEnd ? s2.analysisEnd.getTime() : 0;
            return t2 - t1;
          });
          if (s.scorecards.length > 0) {
            s.scorecardLink = s.scorecards[0].scorecardLink;
          }
        });
      });
    });
  });
};
const updateGates = (featureId, gatesTenantName, progressionCloneGroups, activeFeatureGatesAsync, pendingApprovalRequests) => {
  let gateResponse;
  if (!!featureId && gatesTenantName) {
    gateResponse = activeFeatureGatesAsync;
  } else {
    gateResponse = { status: AsyncRequestStatus.Completed };
  }
  ___default.forOwn(progressionCloneGroups, (progressions) => {
    ___default.forEach(progressions, (progression) => {
      const progressionGates = (gateResponse == null ? void 0 : gateResponse.data) && gateResponse.data[progression.id];
      progression.gates = { status: gateResponse.status, data: progressionGates };
      const progressionPendingApprovals = gatingUtils.getWaitingApprovalGates(
        ApprovalEntityType.progression,
        progression.id,
        progression.name,
        progressionGates
      );
      pendingApprovalRequests.push(...progressionPendingApprovals);
      ___default.forEach(progression.filteredProgressionStages, (progStage) => {
        const stageGates = (gateResponse == null ? void 0 : gateResponse.data) && gateResponse.data[progStage.id];
        progStage.gates = { status: gateResponse.status, data: stageGates };
        const stageFriendlyName = `${progression.name} - ${progStage.friendlyName}`;
        const stagePendingApprovals = gatingUtils.getWaitingApprovalGates(
          ApprovalEntityType.progressionStage,
          progStage.id,
          stageFriendlyName,
          stageGates
        );
        pendingApprovalRequests.push(...stagePendingApprovals);
        updateGatesForProgressionStage(progStage, stageFriendlyName, gateResponse, pendingApprovalRequests);
        if (!!progStage.restartedFrom) {
          updateGatesForProgressionStage(progStage.restartedFrom, stageFriendlyName, gateResponse, pendingApprovalRequests);
        }
      });
    });
  });
};
const updateGatesForProgressionStage = (progressionStage, stageFriendlyName, gateResponse, pendingApprovalRequests) => {
  ___default.forEach(progressionStage.stages, (expStage, index) => {
    const expStageGates = (gateResponse == null ? void 0 : gateResponse.data) && gateResponse.data[expStage.gatingEntityId] || [];
    const legacyStageGates = (gateResponse == null ? void 0 : gateResponse.data) && gateResponse.data[expStage.stepIds[0]] || [];
    const stepGates = [...expStageGates, ...legacyStageGates];
    expStage.gates = { status: gateResponse.status, data: stepGates };
    const stepPendingApprovals = gatingUtils.getWaitingApprovalGates(
      ApprovalEntityType.progressionStep,
      expStage.gatingEntityId,
      `${stageFriendlyName} (step ${index + 1})`,
      stepGates
    );
    pendingApprovalRequests.push(...stepPendingApprovals);
  });
};
let cachedId = null;
let cachedInput = null;
let cachedResponse = {
  archivedProgressionCloneGroupsV2: {},
  mdsSnapshotProgressionTemplatesMap: {},
  progressionCloneGroups: {},
  pendingApprovalRequests: []
};
const progressionCloneGroupsUtil = (input) => {
  const {
    managementGroup,
    defaultSnapshot,
    parsedFeature,
    progressionsAsync,
    progressionStagesAsync,
    mdsFiltersAsync,
    mdsProgressionTemplatesAsync,
    mdsExperimentTemplatesAsync,
    mdsControlTowerExperienceAsync,
    mdsSnapshotTemplates,
    activeFeatureGatesAsync,
    featureScorecardsAsync
  } = input;
  const resourcesLoaded = allRequestsHaveCompleted(
    ___default.map(
      [
        defaultSnapshot,
        mdsFiltersAsync,
        mdsProgressionTemplatesAsync,
        mdsExperimentTemplatesAsync,
        mdsControlTowerExperienceAsync,
        ...___default.values(progressionsAsync).map((p) => p[IReducerKeys.progression_normalized_async]),
        ...___default.values(progressionStagesAsync).map((p) => p[IReducerKeys.progression_stage_async])
      ],
      (resource) => resource.status
    )
  );
  if (parsedFeature.featureMetadata.id !== cachedId) {
    cachedId = parsedFeature.featureMetadata.id;
    cachedInput = null;
    cachedResponse = {
      archivedProgressionCloneGroupsV2: {},
      mdsSnapshotProgressionTemplatesMap: {},
      progressionCloneGroups: {},
      pendingApprovalRequests: []
    };
  }
  if (!!!parsedFeature.featureMetadata.id) {
    return {
      archivedProgressionCloneGroupsV2: {},
      mdsSnapshotProgressionTemplatesMap: {},
      progressionCloneGroups: {},
      pendingApprovalRequests: []
    };
  } else if (!___default.isEqual(input, cachedInput) && !!resourcesLoaded) {
    console.log("parsed progressions");
    cachedInput = ___default.cloneDeep(input);
    const response = progressionCloneGroupsUtilInner({
      managementGroup,
      defaultSnapshot,
      parsedFeature,
      progressionsAsync,
      progressionStagesAsync,
      mdsFiltersAsync,
      mdsProgressionTemplatesAsync,
      mdsExperimentTemplatesAsync,
      mdsControlTowerExperienceAsync,
      mdsSnapshotTemplates,
      activeFeatureGatesAsync,
      featureScorecardsAsync
    });
    cachedResponse = ___default.cloneDeep(response);
    return response;
  } else {
    console.log("returned progressions");
    return cachedResponse;
  }
};
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);
const getFeatureId = (state, props) => props.rolloutId;
const getFlightName = (state, props) => props.flightName;
const getProgressionId = (state, props) => props.progressionId;
const getProgressionStageId = (state, props) => props.progressionStageId;
const getUserAffinity = (state) => _.get(state.currentUserDetails, ["userAffinity"]);
const getOverrides = (state) => _.get(state, ["overrides"]);
const getFlightNameValidation = (state) => _.get(state.featureData, ["flightNameValidation"]);
const getFeaturesData = (state) => _.get(state.progressions, [IReducerKeys.features]);
const getMdsData = (state) => _.get(state.mds, [IReducerKeys$1.mds_data]);
const getMdsSnapShotData = (state) => _.get(state.mds, [IReducerKeys$1.mds_snapshot_data]);
const getMdsMissingSnapshotNames = (state) => _.get(state.mds, [IReducerKeys$1.mds_missing_snapshot_names]);
const getMdsWorkspaceData = (state) => _.get(state.mds, [IReducerKeys$1.mds_workspace_data]);
const getProgressionsDict = (state) => _.get(state.progressions, [IReducerKeys.progressions_dict]);
const getProgressionStagesDict = (state) => _.get(state.progressions, [IReducerKeys.progression_stages_dict]);
const getFlightsData = (state) => _.get(state.progressions, [IReducerKeys.flights]);
const getRootFeatureAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.root_feature_async], getDefaultAsyncWrapperObj())
);
const getFeatureOperationChecksAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.operation_check_async], getDefaultAsyncWrapperObj())
);
const getActiveGatesForFeatureAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.active_gates_async], getDefaultAsyncWrapperObj())
);
const getFeatureScorecardsAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(
    featureData,
    [featureId, IReducerKeys.feature_scorecards_async],
    getDefaultAsyncWrapperObj()
  )
);
const getFeatureInitializingAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.feature_initialize_async], getCompletedAsyncWrapperObj(""))
);
const getBudgetInfo = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.budget_info], {})
);
const getRootFeatureTreatmentFlights = createDeepEqualSelector(
  [getRootFeatureAsync],
  (rootFeatureAsync) => {
    const featureFlights = _.get(rootFeatureAsync, ["data", "Flights"], []);
    return _.filter(featureFlights, (flight) => (flight == null ? void 0 : flight.FlightType) === FlightType.Treatment);
  }
);
const getRootFeatureAssignmentUnit = createDeepEqualSelector(
  [getRootFeatureAsync],
  (rootFeatureAsync) => {
    var _a;
    return ((_a = rootFeatureAsync.data) == null ? void 0 : _a.AssignmentUnit) || "";
  }
);
const getManagementGroup = createDeepEqualSelector(
  [getRootFeatureAsync, getUserAffinity, getRouteLocationSearchGroup],
  (rootFeatureAsync, userAffinityAsync, groupId) => {
    var _a, _b, _c, _d, _e;
    return (_e = (_d = (_b = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.ManagementGroup) != null ? _b : groupId) != null ? _d : (_c = userAffinityAsync == null ? void 0 : userAffinityAsync.data) == null ? void 0 : _c.managementGroup) != null ? _e : "";
  }
);
const getWorkspaceId = createDeepEqualSelector(
  [getRootFeatureAsync, getUserAffinity],
  (rootFeatureAsync, userAffinityAsync) => {
    var _a, _b, _c;
    return (_c = ((_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.WorkspaceId) || ((_b = userAffinityAsync == null ? void 0 : userAffinityAsync.data) == null ? void 0 : _b.workspaceId)) != null ? _c : "";
  }
);
const getExperimentationGroupId = createDeepEqualSelector(
  [getWorkspaceId, getManagementGroup],
  (workspaceId, managementGroup) => getExperimentationGroupIdFromPath(workspaceId, managementGroup)
);
const getRootFeatureGatesTenantName = createDeepEqualSelector(
  [getWorkspaceId, getRootFeatureAsync, getManagementGroup, getWSSPlitMigrationDataSelector],
  (workspaceId, featureAsync, managementGroup, migrationData) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (EnvironmentService.getGatingTenantFromMigrationRecord()) {
      var metadataTenant = (_b = (_a = featureAsync == null ? void 0 : featureAsync.data) == null ? void 0 : _a.GateSetMetadata) == null ? void 0 : _b.TenantName;
      if (!!metadataTenant) {
        return metadataTenant;
      }
      const managementGroupId = !!managementGroup ? getExperimentationGroupIdFromPath(workspaceId, managementGroup) : "";
      const migrationConfig = (_c = getMigrationDataByNewExperimentationGroupId((migrationData == null ? void 0 : migrationData.data) || [], managementGroupId, workspaceId)) != null ? _c : getExperimentationGroupMigationData((migrationData == null ? void 0 : migrationData.data) || [], managementGroupId, workspaceId);
      const tenant = (_d = migrationConfig == null ? void 0 : migrationConfig.OldExperimentationGroupRootName) != null ? _d : getTenantFromManagementGroup(managementGroup);
      logger.trackEvent({
        name: ProgressionsTelemetryMetricNames.FeatureProgression_GetRootFeatureGatesTenantName,
        properties: {
          featureManagementGroup: managementGroup,
          featureWorkspaceId: workspaceId,
          useLegacyTenant: !!(migrationConfig == null ? void 0 : migrationConfig.OldExperimentationGroupRootName),
          gatingTenant: tenant
        },
        measurements: {}
      });
      return tenant;
    } else {
      return (_g = (_f = (_e = featureAsync == null ? void 0 : featureAsync.data) == null ? void 0 : _e.GateSetMetadata) == null ? void 0 : _f.TenantName) != null ? _g : getTenantFromManagementGroup(managementGroup);
    }
  }
);
const getWorkspaceIsolationGroups = createDeepEqualSelector(
  [getWorkspaceId, getMdsWorkspaceData],
  (workspaceId, mdsworkspaceData) => _.get(
    mdsworkspaceData,
    [workspaceId, IReducerKeys$1.workspace_isolation_groups],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsFlightControlAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(mdsData, [managementGroup, IReducerKeys$1.mds_flight_control_async], getDefaultAsyncWrapperObj())
);
const getShowVNextProgressionPage = createDeepEqualSelector(
  [getRootFeatureAsync, getMdsFlightControlAsync],
  (rootFeatureAsync, flightControlAsync) => {
    var _a;
    var isVNextData = rootFeatureAsync.data ? !!rootFeatureAsync.data.IsVNextData : !((_a = flightControlAsync == null ? void 0 : flightControlAsync.data) == null ? void 0 : _a.EnableVCurrentCreateModeForAdapter);
    return showVNextProgressionPage(isVNextData);
  }
);
const getWorkspaceAssignmentUnits = createDeepEqualSelector(
  [getWorkspaceId, getMdsWorkspaceData],
  (workspaceId, mdsWorkspaceData) => _.get(
    mdsWorkspaceData,
    [workspaceId, IReducerKeys$1.workspace_assignment_units],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsControlTowerExperienceAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(
    mdsData,
    [managementGroup, IReducerKeys$1.mds_control_tower_experience_async],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsExperimentTemplatesAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(
    mdsData,
    [managementGroup, IReducerKeys$1.mds_experiment_templates_async],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsExperimentTrafficFiltersAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData, getShowVNextProgressionPage],
  (managementGroup, mdsData, showVNextProgressionPage2) => {
    if (!showVNextProgressionPage2) {
      return _.get(
        mdsData,
        [managementGroup, IReducerKeys$1.mds_experiment_traffic_filters_async],
        getDefaultAsyncWrapperObj()
      );
    } else {
      const _a = _.get(
        mdsData,
        [managementGroup, IReducerKeys$1.eg_traffic_filters],
        getDefaultAsyncWrapperObj()
      ), { data } = _a, rest = __objRest(_a, ["data"]);
      return __spreadProps(__spreadValues({}, rest), {
        data: convertFilterPolicyV2(data || [])
      });
    }
  }
);
const getMdsProgressionTemplatesAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData, getMdsExperimentTrafficFiltersAsync],
  (managementGroup, mdsData, { data: mdsTrafficFilters }) => {
    var _a;
    const mdsProgressionTemplateAsync = _.get(
      mdsData,
      [managementGroup, IReducerKeys$1.mds_progression_templates_async],
      getDefaultAsyncWrapperObj()
    );
    return __spreadProps(__spreadValues({}, mdsProgressionTemplateAsync), {
      data: MasterDataUtilInstance.normalizeProgressionTemplatesTrafficFilters(
        (_a = mdsProgressionTemplateAsync == null ? void 0 : mdsProgressionTemplateAsync.data) != null ? _a : { ProgressionTemplates: {} },
        mdsTrafficFilters
      )
    });
  }
);
const getMdsExperimentExtensionsAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(
    mdsData,
    [managementGroup, IReducerKeys$1.mds_experiment_extensions_async],
    getDefaultAsyncWrapperObj()
  )
);
const getMdsAnalysisConfigAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(mdsData, [managementGroup, IReducerKeys$1.mds_analysis_config_async], getDefaultAsyncWrapperObj())
);
const getMdsExperimentPermissionAsync = createDeepEqualSelector(
  [getManagementGroup, getMdsData],
  (managementGroup, mdsData) => _.get(mdsData, [managementGroup, IReducerKeys$1.mds_experiment_permission_async], getDefaultAsyncWrapperObj())
);
const getMdsDefaultSnapshotAsync = createDeepEqualSelector(
  [getMdsSnapShotData, getWorkspaceId],
  (snapshotData, workspaceId) => _.get(snapshotData, [IReducerKeys$1.mds_default_snapshots, workspaceId], getDefaultAsyncWrapperObj())
);
const getMdsSnapShots = createDeepEqualSelector(
  [getMdsSnapShotData, getManagementGroup],
  (snapshotData, managementGroup) => _.get(snapshotData, [IReducerKeys$1.mds_snapshots, managementGroup], {})
);
const getMdsSnapShotsProgressionTemplatesWithAsync = createDeepEqualSelector(
  [getMdsSnapShotData, getManagementGroup],
  (snapshotData, managementGroup) => {
    const snapshotNameToMdsReduxData = _.get(snapshotData, [
      IReducerKeys$1.mds_snapshots,
      managementGroup
    ]);
    return _.reduce(
      snapshotNameToMdsReduxData,
      (existing, newVal, key) => __spreadProps(__spreadValues({}, existing), { [key]: newVal == null ? void 0 : newVal[IReducerKeys$1.mds_progression_templates_async] }),
      {}
    );
  }
);
const getMdsSnapShotsProgressionTemplates = createDeepEqualSelector(
  [getMdsSnapShotsProgressionTemplatesWithAsync, getMdsExperimentTrafficFiltersAsync],
  (snapshotProgressionTemplatesWithAsync, { data: mdsTrafficFilters }) => _.reduce(
    snapshotProgressionTemplatesWithAsync,
    (existing, { data }, key) => __spreadProps(__spreadValues({}, existing), {
      [key]: MasterDataUtilInstance.normalizeProgressionTemplatesTrafficFilters(
        data != null ? data : { ProgressionTemplates: {} },
        mdsTrafficFilters
      )
    }),
    {}
  )
);
const getCreateProgressionAsync = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.progression_create_async], getCompletedAsyncWrapperObj(""))
);
const getUpdateProgressionAsync = createDeepEqualSelector(
  [getProgressionsDict, getProgressionId],
  (progressionData, progressionId) => _.get(progressionData, [progressionId, IReducerKeys.progression_update_async], getDefaultAsyncWrapperObj())
);
const getRootFeatureProgressionsList = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureData, featureId) => _.get(featureData, [featureId, IReducerKeys.progression_list_async], getDefaultAsyncWrapperObj())
);
const getProgressionAsync = createDeepEqualSelector(
  [getProgressionsDict, getProgressionId],
  (progressionData, progressionId) => _.get(
    progressionData,
    [progressionId, IReducerKeys.progression_normalized_async],
    getDefaultAsyncWrapperObj()
  )
);
const getRootFeatureProgressionsDict = createDeepEqualSelector(
  [getProgressionsDict, getRootFeatureProgressionsList],
  (progressions, { data: progressionIds = [] }) => _.reduce(
    progressions,
    (existing, newVal, key) => (progressionIds == null ? void 0 : progressionIds.includes(key)) ? __spreadProps(__spreadValues({}, existing), { [key]: newVal }) : __spreadValues({}, existing),
    {}
  )
);
const getProgressionMigrationAsync = createDeepEqualSelector(
  [getProgressionsDict, getProgressionId],
  (progressionData, progressionId) => {
    var _a, _b;
    const progressionAsync = _.get(
      progressionData,
      [progressionId, IReducerKeys.progression_migration_async],
      getDefaultAsyncWrapperObj()
    );
    return {
      data: { MigratedUrl: (_b = (_a = progressionAsync == null ? void 0 : progressionAsync.data) == null ? void 0 : _a.ConfigProviderInfo) == null ? void 0 : _b.ConfigProviderMigrationUrl },
      status: progressionAsync.status
    };
  }
);
const getProgressionBulkEditStatusAsync = createDeepEqualSelector(
  [getProgressionsDict, getProgressionId],
  (progressionData, progressionId) => {
    return _.get(
      progressionData,
      [progressionId, IReducerKeys.bulk_edit_progression_stages_async],
      getDefaultAsyncWrapperObj()
    );
  }
);
const getRootFeatureProgressionStages = createDeepEqualSelector(
  [getRootFeatureProgressionsDict, getProgressionStagesDict],
  (progressions, progressionStages) => {
    const progressionStageIds = _.map(
      progressions,
      (progression) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = progression == null ? void 0 : progression[IReducerKeys.progression_normalized_async]) == null ? void 0 : _a.data) == null ? void 0 : _b.Studies) != null ? _c : [];
      }
    ).flat();
    return _.reduce(
      progressionStages,
      (existing, newVal, key) => progressionStageIds.includes(key) ? __spreadProps(__spreadValues({}, existing), { [key]: newVal }) : __spreadValues({}, existing),
      {}
    );
  }
);
const getProgressionIdOfProgressionStage = createDeepEqualSelector(
  [getRootFeatureProgressionsDict, getProgressionStageId],
  (progressions, progressionStageId) => {
    var _a, _b, _c;
    const progressionReduxData = _.find(
      progressions,
      (p) => {
        var _a2, _b2, _c2;
        return ((_c2 = (_b2 = (_a2 = p == null ? void 0 : p[IReducerKeys.progression_normalized_async]) == null ? void 0 : _a2.data) == null ? void 0 : _b2.Studies) != null ? _c2 : []).includes(progressionStageId);
      }
    );
    return (_c = (_b = (_a = progressionReduxData == null ? void 0 : progressionReduxData[IReducerKeys.progression_normalized_async]) == null ? void 0 : _a.data) == null ? void 0 : _b.Id) != null ? _c : "";
  }
);
const getRootFeatureProgressionStagesOperations = createDeepEqualSelector(
  [getRootFeatureProgressionStages],
  (progressionStages) => _.reduce(
    progressionStages,
    (existing, stageReduxData, stageId) => __spreadProps(__spreadValues({}, existing), {
      [stageId]: stageReduxData == null ? void 0 : stageReduxData[IReducerKeys.progression_stage_operation_check_async]
    }),
    {}
  )
);
const getProgressionStageOperationsAsync = createDeepEqualSelector(
  [getProgressionStageId, getProgressionStagesDict],
  (stageId, progressionStages) => _.get(
    progressionStages,
    [stageId, IReducerKeys.progression_stage_operation_check_async],
    getDefaultAsyncWrapperObj()
  )
);
const getProgressionStageAlertsAsync = createDeepEqualSelector(
  [getProgressionStageId, getProgressionStagesDict],
  (stageId, progressionStages) => {
    const alertsAsync = _.get(
      progressionStages,
      [stageId, IReducerKeys.progression_stage_alerts_async],
      getDefaultAsyncWrapperObj()
    );
    const alertObj = {
      result: alertsAsync.data,
      error: alertsAsync.error,
      id: stageId
    };
    const qualityAlerts = AlertUtils.parseQualityAlertsVNext(alertObj);
    return __spreadProps(__spreadValues({}, alertsAsync), { data: qualityAlerts });
  }
);
const getProgressionStageResolveAlertsAsync = createDeepEqualSelector(
  [getProgressionStageId, getProgressionStagesDict],
  (stageId, progressionStages) => {
    return _.get(
      progressionStages,
      [stageId, IReducerKeys.progression_stage_resolve_alerts_async],
      getDefaultAsyncWrapperObj()
    );
  }
);
const getRootFeatureAutoTriggerStateData = createDeepEqualSelector(
  [getFeaturesData, getFeatureId],
  (featureAutoTriggerStateData, featureId) => _.get(
    featureAutoTriggerStateData,
    [featureId, IReducerKeys.feature_auto_trigger_state_async],
    getDefaultAsyncWrapperObj()
  )
);
const getExtraProgressionData = createDeepEqualSelector(
  [getActiveGatesForFeatureAsync, getFeatureScorecardsAsync],
  (activeFeatureGatesAsync, featureScorecardsAsync) => ({
    activeFeatureGatesAsync,
    featureScorecardsAsync
  })
);
const getParsedFeature = createDeepEqualSelector(
  [
    getRootFeatureAsync,
    getMdsFlightControlAsync,
    getMdsControlTowerExperienceAsync,
    getMdsExperimentPermissionAsync,
    getFeatureOperationChecksAsync,
    getManagementGroup,
    getWorkspaceIsolationGroups,
    getWorkspaceId,
    getWorkspaceAssignmentUnits,
    getShowVNextProgressionPage
  ],
  (rootFeatureAsync, mdsFlightControlAsync, mdsControlTowerExperienceAsync, mdsExperimentPermissionAsync, featureOperationChecksAsync, managementGroup, isolationGroups, workspaceId, assignmentUnits, showVNextProgressionPage2) => {
    var _a, _b, _c;
    return parseFeature({
      feature: (_a = rootFeatureAsync.data) != null ? _a : null,
      flightControl: mdsFlightControlAsync.data,
      ctExperience: mdsControlTowerExperienceAsync.data,
      isAuthorized: mdsExperimentPermissionAsync.data,
      operationCheckAsync: featureOperationChecksAsync,
      managementGroup,
      isolationGroups: ((_b = isolationGroups == null ? void 0 : isolationGroups.data) == null ? void 0 : _b.value) || [],
      workspaceId,
      assignmentUnits: ((_c = assignmentUnits == null ? void 0 : assignmentUnits.data) == null ? void 0 : _c.value) || [],
      showVNextProgressionPage: showVNextProgressionPage2
    });
  }
);
const getProgressionCloneGroups = createDeepEqualSelector(
  [
    getManagementGroup,
    getMdsDefaultSnapshotAsync,
    getParsedFeature,
    getRootFeatureProgressionsDict,
    getRootFeatureProgressionStages,
    getMdsExperimentTrafficFiltersAsync,
    getMdsProgressionTemplatesAsync,
    getMdsExperimentTemplatesAsync,
    getMdsControlTowerExperienceAsync,
    getMdsSnapShots,
    getExtraProgressionData
  ],
  (managementGroup, defaultSnapshot, parsedFeature, progressionsAsync, progressionStagesAsync, mdsFiltersAsync, mdsProgressionTemplatesAsync, mdsExperimentTemplatesAsync, mdsControlTowerExperienceAsync, mdsSnapshotTemplates, { activeFeatureGatesAsync, featureScorecardsAsync }) => {
    return progressionCloneGroupsUtil({
      managementGroup,
      defaultSnapshot,
      parsedFeature,
      progressionsAsync,
      progressionStagesAsync,
      mdsFiltersAsync,
      mdsProgressionTemplatesAsync,
      mdsExperimentTemplatesAsync,
      mdsControlTowerExperienceAsync,
      mdsSnapshotTemplates,
      activeFeatureGatesAsync,
      featureScorecardsAsync
    });
  }
);
const getIsFlightGettingUsedInProgressions = createDeepEqualSelector(
  [getFlightName, getProgressionCloneGroups],
  (flightName, progressions) => {
    const { progressionCloneGroups } = progressions;
    return ProgressionUtilsInstance.isFlightGettingUsedInProgression(progressionCloneGroups, flightName);
  }
);
const getIsFlightGettingUsedInOverrides = createDeepEqualSelector(
  [getFlightName, getOverrides],
  (flightName, overrides) => {
    return ProgressionUtilsInstance.isFlightGettingUsedInOverride(overrides, flightName);
  }
);
const getIsFlightGettingUsedInProgressionsAndOverrides = createDeepEqualSelector(
  [getIsFlightGettingUsedInProgressions, getIsFlightGettingUsedInOverrides],
  (IsFlightGettingUsedInProgressions, isFlightGettingUsedInOverrides) => IsFlightGettingUsedInProgressions || isFlightGettingUsedInOverrides
);
const getIsShadowExperiment = createDeepEqualSelector(
  [getRootFeatureAsync],
  (rootFeatureAsync) => {
    var _a, _b;
    return ((_b = (_a = rootFeatureAsync == null ? void 0 : rootFeatureAsync.data) == null ? void 0 : _a.Tags) == null ? void 0 : _b.includes("IsShadowExperiment")) || false;
  }
);
const getFeatureMetadata = (state) => {
  var _a, _b;
  const featureId = (_a = state.currentProgressionReducer) == null ? void 0 : _a.currentFeatureId;
  return (_b = getParsedFeature(state, { rolloutId: featureId })) != null ? _b : {
    featureMetadata: getDefaultFeatureMetadata(),
    flightList: getInitialFlightList()
  };
};
const getMdsSections = (state) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const featureId = (_a = state.currentProgressionReducer) == null ? void 0 : _a.currentFeatureId;
  return {
    controlTowerExperience: (_b = getMdsControlTowerExperienceAsync(state, { rolloutId: featureId })) == null ? void 0 : _b.data,
    flightControl: (_c = getMdsFlightControlAsync(state, { rolloutId: featureId })) == null ? void 0 : _c.data,
    trafficFilters: (_d = getMdsExperimentTrafficFiltersAsync(state, { rolloutId: featureId })) == null ? void 0 : _d.data,
    progressionTemplates: (_f = (_e = getMdsProgressionTemplatesAsync(state, { rolloutId: featureId })) == null ? void 0 : _e.data) == null ? void 0 : _f.ProgressionTemplates,
    experimentTemplates: (_g = getMdsExperimentTemplatesAsync(state, { rolloutId: featureId })) == null ? void 0 : _g.data,
    experimentExtensions: (_h = getMdsExperimentExtensionsAsync(state, { rolloutId: featureId })) == null ? void 0 : _h.data,
    analysisConfig: (_i = getMdsAnalysisConfigAsync(state, { rolloutId: featureId })) == null ? void 0 : _i.data,
    mdsSnapshotProgressionTemplatesMap: getMdsSnapShotsProgressionTemplates(state, { rolloutId: featureId })
  };
};
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
let GatingActions = class {
  loadActiveGatesForFeature() {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        yield dispatch(this.setupLoadActiveGatesForFeature());
        return dispatch(this.fetchActiveGatesForFeature());
      });
      return inner;
    });
  }
  setupLoadActiveGatesForFeature() {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        const setupMetadata = {
          status: AsyncRequestStatus.Pending
        };
        dispatch(this.mapGateResponseToFeature(setupMetadata));
      });
      return inner;
    });
  }
  fetchActiveGatesForFeature() {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        var _a, _b, _c, _d;
        const featureId = (_a = getState().currentProgressionReducer) == null ? void 0 : _a.currentFeatureId;
        let gatesTenantName = "";
        if (EnvironmentService.getGatingTenantFromMigrationRecord()) {
          gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureId });
        } else {
          const feature = getFeatureMetadata(getState()).featureMetadata;
          const managementGroup = (_b = feature == null ? void 0 : feature.managementGroup) != null ? _b : getManagementGroup(getState(), { rolloutId: featureId });
          const tenantName = getTenantFromManagementGroup$1(managementGroup);
          gatesTenantName = (_d = (_c = feature == null ? void 0 : feature.gatesMetadata) == null ? void 0 : _c.TenantName) != null ? _d : tenantName;
        }
        let gates;
        if (!!featureId && !!gatesTenantName) {
          gates = yield GatingResource.getActiveGates(gatesTenantName, featureId);
        } else {
          gates = {
            status: AsyncRequestStatus.Completed
          };
        }
        dispatch(loadActiveFeatureGatesEpicReducer.actionCreators.loaded({ featureId, gatesTenantName }, gates));
        dispatch(this.mapGateResponseToFeature(gates));
      });
      return inner;
    });
  }
  mapGateResponseToFeature(entityGateMapping) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        dispatch(overrideActions.updateGates(entityGateMapping));
      });
      return inner;
    });
  }
  setGateStateAndRefresh(gate, newState, message) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        yield dispatch(this.setGateState(gate, newState, message));
        dispatch(this.loadActiveGatesForFeature());
      });
      return inner;
    });
  }
  setGateState(gate, newState, message) {
    return __async(this, null, function* () {
      const updatedGate = __spreadProps(__spreadValues({}, gate), {
        state: GateState[newState] || gate.state,
        reason: message || gate.reason
      });
      return yield GatingResource.updateGate(updatedGate);
    });
  }
};
__decorateClass$1([
  aggregateAction()
], GatingActions.prototype, "loadActiveGatesForFeature", 1);
__decorateClass$1([
  aggregateAction()
], GatingActions.prototype, "setupLoadActiveGatesForFeature", 1);
__decorateClass$1([
  aggregateAction()
], GatingActions.prototype, "fetchActiveGatesForFeature", 1);
__decorateClass$1([
  aggregateAction()
], GatingActions.prototype, "mapGateResponseToFeature", 1);
__decorateClass$1([
  aggregateAction()
], GatingActions.prototype, "setGateStateAndRefresh", 1);
GatingActions = __decorateClass$1([
  actionClass()
], GatingActions);
const gatingActions = new GatingActions();
const fetchAndUpdateBudgetInfo = (featureId, templateName, request, dispatch) => __async(void 0, null, function* () {
  const budgetResults = yield BudgetResources.calculateTrafficUsage(request);
  dispatch(
    loadBudgetInfoEpicReducer.actionCreators.loaded({ featureId, templateName, request }, getResponseAsyncData(budgetResults))
  );
  return budgetResults;
});
const getResponseAsyncData = (response) => {
  var _a, _b;
  if (!response) {
    return {
      data: null,
      status: AsyncRequestStatus.Failed,
      error: "Progressions: No response returned"
    };
  }
  return response.isSuccessful() ? {
    data: response.getSuccessData(),
    status: AsyncRequestStatus.Completed,
    error: void 0,
    errorContext: void 0
  } : {
    data: null,
    status: AsyncRequestStatus.Failed,
    error: (_b = (_a = response == null ? void 0 : response.errorContext) == null ? void 0 : _a.displayError) != null ? _b : "No error information is present",
    errorContext: response.errorContext
  };
};
const getProgressionCloneGroupsInState = (state, isArchived = false) => {
  var _a;
  const rolloutId = (_a = state.currentProgressionReducer) == null ? void 0 : _a.currentFeatureId;
  const { progressionCloneGroups, archivedProgressionCloneGroupsV2 } = getProgressionCloneGroups(state, { rolloutId });
  return isArchived ? archivedProgressionCloneGroupsV2 : progressionCloneGroups;
};
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let FeatureDataActions = class {
  resetFeatureDataActionsState() {
    overrideActions.resetOverrideActionsState();
    return null;
  }
  createFeatureV2Aggregate(formData, postData) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const response = yield dispatch(this.createFeatureV2(formData, postData));
        if (EnvironmentService.enableAutoTriggerToggle()) {
          logger.trackMetric({
            average: formData.isFeatureAutoTriggered !== null ? 1 : 0,
            name: ProgressionsTelemetryMetricNames.Feature_AutomaticTriggerredStateAction_Create,
            properties: { autoTriggerState: formData.isFeatureAutoTriggered }
          });
          yield dispatch(this.setFeatureAutoTriggerState(response.payload.featureId, formData, postData.WorkspaceId));
        }
        dispatch(currentFeatureIdActionCreator({ currentFeatureId: response.payload.featureId }));
        dispatch(
          loadRootFeatureEpicReducer.actionCreators.load({ featureId: response.payload.featureId, dontLogInitialPLT: true })
        );
        return response;
      });
      return inner;
    });
  }
  createFeatureV2(formData, postData) {
    return __async(this, null, function* () {
      const response = yield featureResource.createRootFeature(postData);
      return {
        formData,
        postData,
        featureId: response
      };
    });
  }
  initializeFeature(featureId) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(featureInitializeEpicReducer.actionCreators.load({ featureId }));
      });
      return inner;
    });
  }
  updateFeatureV2(featureMetadata, formData, postData) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(this.updateFeatureInternalV2(featureMetadata.id, formData, postData));
        if (EnvironmentService.enableAutoTriggerToggle()) {
          logger.trackMetric({
            average: formData.isFeatureAutoTriggered !== null ? 1 : 0,
            name: ProgressionsTelemetryMetricNames.Feature_AutomaticTriggerredStateAction_Edit,
            properties: { autoTriggerState: formData.isFeatureAutoTriggered }
          });
          yield dispatch(this.setFeatureAutoTriggerState(featureMetadata.id, formData, featureMetadata.workspaceId));
        }
        yield dispatch(
          loadRootFeatureEpicReducer.actionCreators.load({
            featureId: featureMetadata.id,
            dontLoadExtraResources: true
          })
        );
      });
      return inner;
    });
  }
  updateFeatureInternalV2(id, formData, postData) {
    return __async(this, null, function* () {
      yield featureResource.updateRootFeature(postData, id);
      return {
        featureId: id,
        formData
      };
    });
  }
  setFeatureAutoTriggerState(id, formData, workspaceId) {
    return __async(this, null, function* () {
      if (formData.isFeatureAutoTriggered !== null)
        yield AnalysisResourceV2.setFeatureAutoTriggeringState(workspaceId, id, formData.isFeatureAutoTriggered);
    });
  }
  loadFeature(featureId) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const promiseList = [];
        dispatch(checkOverviewMainFunctionality(performance.now()));
        const state = getState();
        const isInitializePending = getFeatureInitializingAsync(state, { rolloutId: featureId }).status === AsyncRequestStatus.Pending;
        const featureMetadata = getFeatureMetadata(getState()).featureMetadata;
        if (!!state && !!state.featureData && !!featureMetadata) {
          if (featureMetadata.id && !featureMetadata.isInitialized && !isInitializePending) {
            dispatch(this.initializeFeature(featureId));
          }
          const feature = featureMetadata;
          if (featureMetadata.enableOverrideTargets) {
            promiseList.push(
              dispatch(
                overrideActions.loadOverrideSetsForFeature(
                  featureId,
                  feature.controlTowerTenant,
                  feature.workspaceId,
                  feature.managementGroup
                )
              )
            );
          }
        }
        new Promise((resolve) => Promise.all(promiseList).then(() => resolve()));
      });
      return inner;
    });
  }
  setupLoadOperationCheck(progressionId, progressionTargetIndex, operationCheckUniqueId, state = "Pending") {
    return __async(this, null, function* () {
      return {
        progressionId,
        progressionTargetIndex,
        operationCheckUniqueId,
        state
      };
    });
  }
  onFetchExperimentJournal(featureId, progressionId, progressionTargetIndex, progressionStageId, oldIteratedStage = false, dispatch) {
    return __async(this, null, function* () {
      yield dispatch(loadProgressionStageJournalsEpicReducer.actionCreators.load({ featureId, progressionStageId }));
      return {};
    });
  }
  validateFlightNameStartedInternalFormik(name) {
    return __async(this, null, function* () {
      return {
        name
      };
    });
  }
  validateFlightNameInternalFormik(name, managementGroup, workspaceId, dispatch) {
    return __async(this, null, function* () {
      const result = yield featureResource.getFlight(name, managementGroup, workspaceId);
      dispatch(
        loadFlightDataEpicReducer.actionCreators.loaded(
          { flight: name, managementGroup, workspaceId },
          getResponseAsyncData(result)
        )
      );
      return {
        name,
        result: result.isSuccessful() ? result.getSuccessData() : null
      };
    });
  }
  toggleProgressionState(progressionId, isExpanded) {
    return __async(this, null, function* () {
      return {
        progressionId,
        isExpanded
      };
    });
  }
  toggleProgression(progression, isExpanded) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        yield dispatch(this.toggleProgressionState(progression.id, isExpanded));
      });
      return inner;
    });
  }
  validateFlightNameFormik(name, managementGroup, workspaceId) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(this.validateFlightNameStartedInternalFormik(name));
        if (!!!managementGroup || !!!workspaceId) {
          const featureMetadata = getFeatureMetadata(getState()).featureMetadata;
          dispatch(
            this.validateFlightNameInternalFormik(name, featureMetadata.managementGroup, featureMetadata.workspaceId, dispatch)
          );
        } else {
          dispatch(this.validateFlightNameInternalFormik(name, managementGroup, workspaceId, dispatch));
        }
      });
      return inner;
    });
  }
  loadProgressionTemplatesAggregate(workspaceId, managementGroup) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        return dispatch(this.loadProgressionTemplates(workspaceId, managementGroup, getState));
      });
      return inner;
    });
  }
  loadProgressionTemplates(workspaceId, managementGroup, getState) {
    return __async(this, null, function* () {
      let { trafficFilters, progressionTemplates, experimentTemplates } = getMdsSections(getState());
      if (!progressionTemplates) {
        progressionTemplates = {};
      }
      Object.keys(progressionTemplates).forEach((key) => !progressionTemplates[key] && delete progressionTemplates[key]);
      trafficFilters = MasterDataUtilInstance.normalizeMdsFilterValues(trafficFilters);
      const overAllProgressionTemplates = MasterDataUtilInstance.normalizeProgressionTemplatesTrafficFilters(
        { ProgressionTemplates: progressionTemplates },
        trafficFilters
      );
      const { controlTowerExperience } = getMdsSections(getState());
      return {
        mdsFilters: trafficFilters,
        mdsProgressionTemplates: overAllProgressionTemplates.ProgressionTemplates,
        mdsExperimentTemplates: experimentTemplates,
        flightList: getFeatureMetadata(getState()).flightList,
        mdsControlTowerExperience: controlTowerExperience
      };
    });
  }
  cloneProgressionInternal(featureRootId, progressionId, progressionSelection, mdsFilters, isAutoGeneratedIsolationGroup, userRequestedResalt, promoteFlight, getState, dispatch) {
    return __async(this, null, function* () {
      const postData = ProgressionSelectionUtilInstance.getProgressionCreateRequest(
        featureRootId,
        progressionSelection,
        isAutoGeneratedIsolationGroup,
        userRequestedResalt,
        promoteFlight
      );
      const newProgressionId = yield featureResource.cloneProgression(featureRootId, progressionId, postData);
      const { managementGroup, workspaceId } = getFeatureMetadata(getState()).featureMetadata;
      const gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureRootId });
      yield dispatch(
        loadSingleProgressionEpicReducer.actionCreators.load({
          featureId: featureRootId,
          progressionId: newProgressionId,
          managementGroup,
          workspaceId,
          gatesTenantName
        })
      );
      return {};
    });
  }
  cloneProgression(featureRootId, progressionId, progressionSelection, mdsFilters, userRequestedResalt, promoteFlight) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const isAutoGeneratedIsolationGroup = getFeatureMetadata(getState()).featureMetadata.isAutoGeneratedIsolationGroup;
        const clonedProgressionData = yield dispatch(
          this.cloneProgressionInternal(
            featureRootId,
            progressionId,
            progressionSelection,
            mdsFilters,
            isAutoGeneratedIsolationGroup,
            userRequestedResalt,
            promoteFlight,
            getState,
            dispatch
          )
        );
        dispatch(this.toggleProgressionState(clonedProgressionData.payload.progressionDto.Id, true));
      });
      return inner;
    });
  }
  createProgressionStage(featureId, progressionId, position, progressionStageConfiguration, userRequestedResalt) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(
          this.createProgressionStageInternal(
            featureId,
            progressionId,
            position,
            progressionStageConfiguration,
            userRequestedResalt,
            getState,
            dispatch
          )
        );
      });
      return inner;
    });
  }
  createProgressionStageInternal(featureId, progressionId, position, progressionStageConfiguration, userRequestedResalt, getState, dispatch) {
    return __async(this, null, function* () {
      progressionStageConfiguration.ResaltOnStart = userRequestedResalt;
      let progressionStageId = yield featureResource.createProgressionStage(
        featureId,
        progressionId,
        position,
        progressionStageConfiguration
      );
      yield dispatch(loadSingleProgressionStageEpicReducer.actionCreators.load({ progressionId, progressionStageId }));
      return {};
    });
  }
  hideFeature(featureRootId) {
    return __async(this, null, function* () {
      yield featureResource.hideFeature(featureRootId);
      return {};
    });
  }
  archiveProgression(featureRootId, progressionId, hideProgression = false) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const workspaceId = getWorkspaceId(getState(), { rolloutId: featureRootId });
        const managementGroup = getManagementGroup(getState(), { rolloutId: featureRootId });
        yield dispatch(
          this.archiveProgressionInternal(
            featureRootId,
            progressionId,
            workspaceId,
            managementGroup,
            hideProgression,
            getState,
            dispatch
          )
        );
      });
      return inner;
    });
  }
  archiveProgressionInternal(featureRootId, progressionId, workspaceId, managementGroup, hideProgression = false, getState, dispatch) {
    return __async(this, null, function* () {
      yield featureResource.archiveProgression(featureRootId, progressionId, hideProgression);
      const gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureRootId });
      yield dispatch(
        loadSingleProgressionEpicReducer.actionCreators.load({
          featureId: featureRootId,
          progressionId,
          managementGroup,
          workspaceId,
          gatesTenantName
        })
      );
      return {};
    });
  }
  updateProgressionStageAggregate(featureId, progressionId, targetId, progressionTargetBackend, progressionStageIndex, setTargetDetailsViewVisibility) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(
          this.updateProgressionStage(featureId, progressionId, targetId, progressionTargetBackend, progressionStageIndex)
        );
        dispatch(this.loadProgressionStage(targetId, progressionId, progressionStageIndex, setTargetDetailsViewVisibility));
      });
      return inner;
    });
  }
  updateProgressionStage(featureId, progressionId, targetId, progressionTargetBackend, progressionStageIndex) {
    return __async(this, null, function* () {
      yield featureResource.updateProgressionsStage(featureId, progressionId, targetId, progressionTargetBackend);
      return {};
    });
  }
  // Todo: Chain actions instead of calling ui update in same method.
  // Todo: Make use of isUpdateSuccessful/isReadSuccessful to provide better messaging to the user.
  actOnProgressionTargetInternal(operation, progression, progressionStageIndex, mdsTrafficFilters, mdsSnapshotProgressionTemplatesMap, mdsProgressionTemplates, oldIteratedStage, hasRunningIteration, state, dispatch, setOperatingStateOfProgressionStage, ignoreHistoricalAllocation) {
    return __async(this, null, function* () {
      var _a;
      if (operation === StudyOperations.transfer) {
        let cloneId = progression.filteredProgressionStages[progressionStageIndex].clonedFromId;
        if (hasRunningIteration) {
          cloneId = progression.filteredProgressionStages[progressionStageIndex].restartedFromId;
        }
        const crossIterationResultResult = yield experimentResource.crossIterationResume(
          progression.filteredProgressionStages[progressionStageIndex].id,
          cloneId,
          true,
          hasRunningIteration,
          ignoreHistoricalAllocation
        );
        crossIterationResultResult.ensureSuccess();
      } else if (operation === StudyOperations.start || operation === StudyOperations.restart) {
        const startResult = yield experimentResource.startExperiment(
          progression.filteredProgressionStages[progressionStageIndex].id,
          true
        );
        startResult.ensureSuccess();
      } else if (operation === StudyOperations.advance) {
        const advannceExperimentResult = yield experimentResource.advanceExperiment(
          progression.filteredProgressionStages[progressionStageIndex].id,
          true
        );
        advannceExperimentResult.ensureSuccess();
      } else if (operation === StudyOperations.stop) {
        let progressionStageId = progression.filteredProgressionStages[progressionStageIndex].id;
        if (oldIteratedStage && progression.filteredProgressionStages[progressionStageIndex].restartedFrom) {
          progressionStageId = progression.filteredProgressionStages[progressionStageIndex].restartedFrom.id;
        }
        const stopExperimentResult = yield experimentResource.stopExperiment(progressionStageId);
        stopExperimentResult.ensureSuccess();
      }
      let expId = progression.filteredProgressionStages[progressionStageIndex].id;
      if (oldIteratedStage) {
        expId = progression.filteredProgressionStages[progressionStageIndex].restartedFromId;
      }
      yield dispatch(
        loadSingleProgressionStageEpicReducer.actionCreators.load({ progressionId: progression.id, progressionStageId: expId })
      );
      if (operation === StudyOperations.transfer) {
        let cloneId = progression.filteredProgressionStages[progressionStageIndex].clonedFromId;
        if (hasRunningIteration) {
          cloneId = progression.filteredProgressionStages[progressionStageIndex].restartedFromId;
        }
        const rolloutId = (_a = state.currentProgressionReducer) == null ? void 0 : _a.currentFeatureId;
        const progressionIdContainingClone = getProgressionIdOfProgressionStage(state, { rolloutId, progressionStageId: cloneId });
        yield dispatch(
          loadSingleProgressionStageEpicReducer.actionCreators.load({
            progressionId: progressionIdContainingClone,
            progressionStageId: cloneId
          })
        );
      }
      setOperatingStateOfProgressionStage(expId, null, "Completed");
      return {};
    });
  }
  loadProgressionStageInternal(targetId, progressionId, progressionStageIndex, getState, dispatch) {
    return __async(this, null, function* () {
      yield dispatch(loadSingleProgressionStageEpicReducer.actionCreators.load({ progressionId, progressionStageId: targetId }));
      return {};
    });
  }
  fetchOperationCheckForFeatureInternal(featureId, dispatch) {
    return __async(this, null, function* () {
      yield dispatch(loadFeatureOperationChecksEpicReducer.actionCreators.load({ featureId }));
      return {};
    });
  }
  //todo: chain actions rather than make multiple api calls
  createProgressionInternal(featureRootId, progressionSelection, mdsFilters, workspaceId, managementGroup, isAutoGeneratedIsolationGroup, userRequestedResalt, getState, dispatch) {
    return __async(this, null, function* () {
      const postData = ProgressionSelectionUtilInstance.getProgressionCreateRequest(
        featureRootId,
        progressionSelection,
        isAutoGeneratedIsolationGroup,
        userRequestedResalt
      );
      const newProgressionId = yield featureResource.createProgression(featureRootId, postData);
      const gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureRootId });
      yield dispatch(
        loadSingleProgressionEpicReducer.actionCreators.load({
          featureId: featureRootId,
          progressionId: newProgressionId,
          managementGroup,
          workspaceId,
          gatesTenantName
        })
      );
      return {};
    });
  }
  deleteProgressionStage(featureId, progressionId, progressionStageId) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(this.deleteProgressionStageInternal(featureId, progressionId, progressionStageId));
        const { managementGroup, workspaceId } = getFeatureMetadata(getState()).featureMetadata;
        const gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureId });
        dispatch(
          loadSingleProgressionEpicReducer.actionCreators.load({
            featureId,
            progressionId,
            managementGroup,
            workspaceId,
            gatesTenantName
          })
        );
      });
      return inner;
    });
  }
  deleteProgressionStageInternal(featureId, progressionId, stageId) {
    return __async(this, null, function* () {
      yield featureResource.deleteProgressionsStage(featureId, progressionId, stageId);
      return {};
    });
  }
  createProgression(featureRootId, progressionSelection, mdsFilters, workspaceId, managementGroup, userRequestedResalt) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const featureMetadata = getFeatureMetadata(getState()).featureMetadata;
        const isAutoGeneratedIsolationGroup = featureMetadata.isAutoGeneratedIsolationGroup;
        let createProgressionData = yield dispatch(
          this.createProgressionInternal(
            featureRootId,
            progressionSelection,
            mdsFilters,
            workspaceId,
            managementGroup,
            isAutoGeneratedIsolationGroup,
            userRequestedResalt,
            getState,
            dispatch
          )
        );
        yield dispatch(this.toggleProgressionState(createProgressionData.payload.progressionDto.Id, true));
      });
      return inner;
    });
  }
  withdrawProgressionStage(featureId, progressionId, progressionStageId) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield featureResource.deleteProgressionsStage(featureId, progressionId, progressionStageId);
        const featureMetadata = getFeatureMetadata(getState()).featureMetadata;
        const { managementGroup, workspaceId } = featureMetadata;
        const gatesTenantName = getRootFeatureGatesTenantName(getState(), { rolloutId: featureId });
        yield dispatch(
          loadProgressionsEpicReducer.actionCreators.load({
            featureId,
            workspaceId,
            managementGroup,
            gatesTenantName,
            onlyArchivedProgressions: false
          })
        );
      });
      return inner;
    });
  }
  loadExperimentJournalInProgressionStage(progressionId, progressionStageIndex, isArchived, oldIteratedStage = false) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const progression = getProgressionInProgressionCloneGroups(
          progressionId,
          getProgressionCloneGroupsInState(getState(), isArchived)
        );
        let progressionStage = progression.filteredProgressionStages[progressionStageIndex];
        if (oldIteratedStage) {
          progressionStage = progressionStage.restartedFrom;
        }
        dispatch(
          this.onFetchExperimentJournal(
            getFeatureMetadata(getState()).featureMetadata.id,
            progressionId,
            progressionStageIndex,
            progressionStage.id,
            oldIteratedStage,
            dispatch
          )
        );
      });
      return inner;
    });
  }
  loadProgressionStage(targetId, progressionId, progressionTargetIndex, setTargetDetailsViewVisibility) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(this.loadProgressionStageInternal(targetId, progressionId, progressionTargetIndex, getState, dispatch));
        setTargetDetailsViewVisibility(false, false);
      });
      return inner;
    });
  }
  fetchOperationCheckForFeature(featureId) {
    return __async(this, null, function* () {
      const inner = (dispatch) => __async(this, null, function* () {
        yield dispatch(this.fetchOperationCheckForFeatureInternal(featureId, dispatch));
      });
      return inner;
    });
  }
  actOnProgressionTarget(operation, progression, progressionTargetIndex, oldIteratedStage = false, hasRunningIteration = false, setOperatingStateOfProgressionStage, ignoreHistoricalAllocation) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        var _a, _b, _c;
        setOperatingStateOfProgressionStage(progression.filteredProgressionStages[progressionTargetIndex].id, operation, "Pending");
        const { trafficFilters, mdsSnapshotProgressionTemplatesMap, progressionTemplates } = getMdsSections(getState());
        const mdsFilters = trafficFilters;
        let res = yield dispatch(
          this.actOnProgressionTargetInternal(
            operation,
            progression,
            progressionTargetIndex,
            mdsFilters,
            mdsSnapshotProgressionTemplatesMap,
            progressionTemplates,
            oldIteratedStage,
            hasRunningIteration,
            getState(),
            dispatch,
            setOperatingStateOfProgressionStage,
            ignoreHistoricalAllocation
          )
        );
        if (!!res.error) {
          setOperatingStateOfProgressionStage(progression.filteredProgressionStages[progressionTargetIndex].id, null, "Failed");
        }
        const workspaceId = ((_c = (_b = (_a = getState().currentUserDetails) == null ? void 0 : _a.userAffinity) == null ? void 0 : _b.data) == null ? void 0 : _c.workspaceId) || "";
        dispatch(
          loadAssignmentDetailsForExperimentEpicReducer.actionCreators.load({
            workspaceId,
            experimentId: progression.filteredProgressionStages[progressionTargetIndex].id
          })
        );
      });
      return inner;
    });
  }
  cloneProgressionStageInternal(featureRootId, progressionId, progressionStageId, progressionStageUpdate, progressionStageIndex, userRequestedResalt, getState, dispatch) {
    return __async(this, null, function* () {
      progressionStageUpdate = __spreadProps(__spreadValues({}, progressionStageUpdate), {
        ResaltOnStart: userRequestedResalt
      });
      const newProgressionStageId = yield featureResource.cloneProgressionStage(
        featureRootId,
        progressionId,
        progressionStageId,
        progressionStageUpdate
      );
      yield dispatch(
        loadSingleProgressionStageEpicReducer.actionCreators.load({ progressionId, progressionStageId: newProgressionStageId })
      );
      return {};
    });
  }
  cloneModifiedProgressionStage(featureRootId, progressionId, progressionStageId, progressionStageUpdate, progressionStageIndex, setTargetDetailsViewVisibility) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        yield dispatch(
          this.cloneProgressionStageInternal(
            featureRootId,
            progressionId,
            progressionStageId,
            progressionStageUpdate,
            progressionStageIndex,
            false,
            getState,
            dispatch
          )
        );
        setTargetDetailsViewVisibility(false, false);
      });
      return inner;
    });
  }
  restartProgressionStage(featureId, progression, progressionStageId, progressionStageIndex, userRequestedResalt, setOperatingStateOfProgressionStage) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
        const operation = StudyOperations.restart;
        setOperatingStateOfProgressionStage(progressionStageId, operation, "Pending");
        let cloneRes = yield dispatch(
          this.cloneProgressionStageInternal(
            featureId,
            progression.id,
            progressionStageId,
            null,
            progressionStageIndex,
            userRequestedResalt,
            getState,
            dispatch
          )
        );
        yield dispatch(gatingActions.fetchActiveGatesForFeature());
        if (!!cloneRes && !cloneRes.error) {
          const { key, index } = findProgressionInProgressionCloneGroups(
            progression.id,
            getProgressionCloneGroupsInState(getState())
          );
          const updatedProgression = getProgressionCloneGroupsInState(getState())[key][index];
          const progressionStageStages = (_c = (_b = (_a = updatedProgression == null ? void 0 : updatedProgression.filteredProgressionStages) == null ? void 0 : _a[progressionStageIndex]) == null ? void 0 : _b.stages) != null ? _c : [];
          if (((_f = (_e = (_d = updatedProgression == null ? void 0 : updatedProgression.gates) == null ? void 0 : _d.data) == null ? void 0 : _e.filter((gate) => compareIgnoreCase(gate.state, "NotSet"))) == null ? void 0 : _f.length) > 0 || ((_j = (_i = (_h = (_g = progressionStageStages == null ? void 0 : progressionStageStages[0]) == null ? void 0 : _g.gates) == null ? void 0 : _h.data) == null ? void 0 : _i.filter((gate) => compareIgnoreCase(gate.state, "NotSet"))) == null ? void 0 : _j.length) > 0) {
            setOperatingStateOfProgressionStage(
              (_k = updatedProgression.filteredProgressionStages) == null ? void 0 : _k[progressionStageIndex].id,
              null,
              "Completed"
            );
          } else {
            yield dispatch(
              this.actOnProgressionTarget(
                operation,
                updatedProgression,
                progressionStageIndex,
                false,
                false,
                setOperatingStateOfProgressionStage
              )
            );
          }
        } else {
          setOperatingStateOfProgressionStage(progression.filteredProgressionStages[progressionStageIndex].id, null, "Failed");
        }
      });
      return inner;
    });
  }
  progressionSelectionUpdated(progressionId, newSelection, prevSelection, shouldForceRefresh = false) {
    return __async(this, null, function* () {
      const inner = (dispatch, getState) => __async(this, null, function* () {
        const isNewProgression = progressionId === null;
        const featureMetadata = getFeatureMetadata(getState()).featureMetadata;
        if (!featureMetadata.isAutoGeneratedIsolationGroup) {
          if (shouldForceRefresh || !isNewProgression && !newSelection.progressionTrafficBudget || // budget data hasn't been loaded yet
          isNewProgression && (newSelection == null ? void 0 : newSelection.selectedProgressionTemplateId) !== (prevSelection == null ? void 0 : prevSelection.selectedProgressionTemplateId)) {
            const { workspaceId, managementGroup, isolationGroups, id } = featureMetadata;
            dispatch(this.updateTrafficBudgetRequestStatus(progressionId, AsyncRequestStatus.Pending));
            dispatch(
              this.loadProgressionBudgetInfo(
                id,
                workspaceId,
                managementGroup,
                isolationGroups,
                progressionId,
                newSelection,
                getProgressionCloneGroupsInState(getState()),
                dispatch
              )
            );
          } else if (newSelection && prevSelection && TrafficFilterUtilInstance.isTrafficFilterValuesChanged(
            newSelection.selectedTrafficFilters,
            prevSelection.selectedTrafficFilters
          )) {
            dispatch(this.updateTrafficBudgetRequestStatus(progressionId, AsyncRequestStatus.Stale));
          }
        }
      });
      return inner;
    });
  }
  updateTrafficBudgetRequestStatus(progressionId, status) {
    return __async(this, null, function* () {
      return {
        progressionId,
        status
      };
    });
  }
  loadProgressionBudgetInfo(featureId, workspaceId, managementGroup, isolationGroups, progressionId, progressionSelection, progressionCloneGroups, dispatch) {
    return __async(this, null, function* () {
      const progression = getProgressionInProgressionCloneGroups(progressionId, progressionCloneGroups);
      let stages;
      if (progression) {
        stages = ___default.map(progression.filteredProgressionStages, (stage) => {
          return { filters: stage.initialTrafficFilters, name: stage.friendlyName };
        });
      } else {
        const progressionStages = ProgressionUtilsInstance.getSelectedTemplateStages(progressionSelection);
        stages = ___default.map(progressionStages, (stage) => {
          return { filters: stage.targetTrafficFilters, name: stage.name };
        });
      }
      const trafficUsages = ___default.map(stages, (stage) => {
        const combinedFilters = TrafficFilterUtilInstance.getCombination(
          stage.filters,
          progressionSelection.selectedTrafficFilters
        );
        return {
          IsolationGroups: isolationGroups,
          TrafficFilters: TrafficFilterUtilInstance.getSelectedTrafficFilters(combinedFilters, false),
          Flights: []
        };
      });
      const calculateTrafficUsageRequest = {
        WorkspaceId: workspaceId,
        ManagementGroup: managementGroup,
        TrafficUsages: trafficUsages
      };
      if (calculateTrafficUsageRequest.TrafficUsages.length > 0) {
        const budgetResults = yield fetchAndUpdateBudgetInfo(
          featureId,
          progressionSelection.selectedProgressionTemplateName,
          calculateTrafficUsageRequest,
          dispatch
        );
        const isCallSuccessful = budgetResults.isSuccessful();
        return {
          budgetCalculationResults: {
            status: isCallSuccessful ? AsyncRequestStatus.Completed : AsyncRequestStatus.Failed,
            data: isCallSuccessful ? budgetResults.getSuccessData() : null
          },
          progressionStages: stages.map((stage) => stage.name),
          progressionId
        };
      } else {
        return {
          budgetCalculationResults: {
            status: AsyncRequestStatus.Completed,
            data: null
          },
          progressionStages: stages.map((stage) => stage.name),
          progressionId
        };
      }
    });
  }
  addToPendingSubmissions(request) {
    return request;
  }
  clearPendingSubmissions() {
    return __async(this, null, function* () {
    });
  }
  startApprovalRequestValidation() {
  }
  completeApprovalRequestValidation(validationResult) {
    return __async(this, null, function* () {
      return validationResult;
    });
  }
  clearValidationRecord() {
  }
};
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "createFeatureV2Aggregate", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "initializeFeature", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "updateFeatureV2", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "loadFeature", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "toggleProgression", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "validateFlightNameFormik", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "loadProgressionTemplatesAggregate", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "cloneProgression", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "createProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "archiveProgression", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "updateProgressionStageAggregate", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "deleteProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "createProgression", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "withdrawProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "loadExperimentJournalInProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "loadProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "fetchOperationCheckForFeature", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "actOnProgressionTarget", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "cloneModifiedProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "restartProgressionStage", 1);
__decorateClass([
  aggregateAction()
], FeatureDataActions.prototype, "progressionSelectionUpdated", 1);
FeatureDataActions = __decorateClass([
  actionClass()
], FeatureDataActions);
const featureDataActions = new FeatureDataActions();
export {
  createProgressionEpicReducer as $,
  getFeatureOperationChecksAsync as A,
  IReducerKeys$1 as B,
  loadRootFeatureEpicReducer as C,
  loadMdsControlTowerExperienceEpicReducer as D,
  loadMdsFlightControlEpicReducer as E,
  loadMdsExperimentPermissionEpicReducer as F,
  loadMdsExperimentExtensionsEpicReducer as G,
  loadMdsProgressionTemplateEpicReducer as H,
  IReducerKeys as I,
  getLoadWorkspaceAssignmentUnitsEpicReducer as J,
  loadWorkspaceIsolationGroupsEpicReducer as K,
  loadMdsAnalysisConfigEpicReducer as L,
  getParsedFeature as M,
  getIsShadowExperiment as N,
  getFeatureInitializingAsync as O,
  getProgressionCloneGroups as P,
  getOverrides as Q,
  getFlightNameValidation as R,
  loadFeatureAutoTriggerStateEpicReducer as S,
  getFeatureMetadata as T,
  getMdsSections as U,
  getRootFeatureGatesTenantName as V,
  getRootFeatureAutoTriggerStateData as W,
  loadProgressionsEpicReducer as X,
  getCreateProgressionAsync as Y,
  getBudgetInfo as Z,
  loadBudgetInfoEpicReducer as _,
  epics$1 as a,
  MIGRATE_PROGRESSION_ACTION_PREFIX as a$,
  getIsFlightGettingUsedInProgressions as a0,
  getIsFlightGettingUsedInProgressionsAndOverrides as a1,
  gatingActions as a2,
  getMdsMissingSnapshotNames as a3,
  getProgressionBulkEditStatusAsync as a4,
  migrateProgressionEpicReducer as a5,
  bulkEditProgressionEpicReducer as a6,
  getProgressionMigrationAsync as a7,
  getProgressionAsync as a8,
  getUpdateProgressionAsync as a9,
  setSingleProgressionStageInReduxLoading as aA,
  setSingleProgressionStageInReduxLoaded as aB,
  afterLoadFeatureActions as aC,
  getProgressionStageOperationsActions as aD,
  afterLoadProgressionsActions as aE,
  reduxActionTypePrefix as aF,
  defaultReducerState as aG,
  defaultProgressionReduxData as aH,
  defaultProgressionStageReduxData as aI,
  loadFeatureOperationChecksEpicReducer as aJ,
  loadActiveFeatureGatesEpicReducer as aK,
  LOAD_PROGRESSIONS_ACTION_PREFIX as aL,
  LOAD_PROGRESSION_STAGE_OPERATION_CHECK as aM,
  loadOperationChecksEpicReducer as aN,
  LOAD_PROGRESSION_STAGE_ALERTS as aO,
  RESOLVE_PROGRESSION_STAGE_ALERTS as aP,
  UPDATE_EXPERIMENT as aQ,
  LOAD_PROGRESSION_STAGE_JOURNALS as aR,
  loadProgressionStageJournalsEpicReducer as aS,
  LOAD_FEATURE_SCORECARDS as aT,
  loadFeatureScorecardsEpicReducer as aU,
  LOAD_FLIGHT_DATA as aV,
  loadFlightDataEpicReducer as aW,
  LOAD_SINGLE_PROGRESSION_ACTION_PREFIX as aX,
  LOAD_SINGLE_PROGRESSION_STAGE_ACTION_PREFIX as aY,
  featureInitializeEpicReducer as aZ,
  UPDATE_PROGRESSION_ACTION_PREFIX as a_,
  updateProgressionEpicReducer as aa,
  loadSingleProgressionEpicReducer as ab,
  loadSingleProgressionStageEpicReducer as ac,
  getRootFeatureAssignmentUnit as ad,
  getProgressionStageAlertsAsync as ae,
  loadProgressionStageAlertsEpicReducer as af,
  updateExperimentEpicReducer as ag,
  getProgressionStageResolveAlertsAsync as ah,
  resolveProgressionStageAlertsEpicReducer as ai,
  FeatureDataActions as aj,
  OverrideActions as ak,
  updateMissingSnapshotNames as al,
  defaultReducerState$1 as am,
  loadExperimentationGroupTrafficFiltersEpicReducerV2 as an,
  loadWorkspaceAssignmentUnitsEpicReducer as ao,
  loadMdsSnapshotProgressionTemplateEpicReducer as ap,
  loadMdsDefaultSnapshotProgressionTemplateEpicReducer as aq,
  loadMdsExperimentTemplatesEpicReducer as ar,
  loadMdsExperimentTrafficFiltersEpicReducer as as,
  setFeatureProgressionsLoading as at,
  setFeatureInReduxWhenProgressionsLoaded as au,
  setFeatureInReduxWhenSingleProgressionLoaded as av,
  setProgressionsInReduxWhenProgressionsLoaded as aw,
  setProgressionStagesInReduxWhenProgressionsLoaded as ax,
  setProgressionInReduxWhenSingleProgressionLoading as ay,
  setProgressionDictInReduxWhenSingleProgressionLoading as az,
  reducer$1 as b,
  LOAD_FEATURE_AUTO_TRIGGER_STATE_ACTION_PREFIX as b0,
  BULK_EDIT_PROGRESSION_ACTION_PREFIX as b1,
  progressionCloneGroupsUtilInner as b2,
  progressionCloneGroupsUtil as b3,
  getFeatureId as b4,
  getFlightName as b5,
  getProgressionId as b6,
  getProgressionStageId as b7,
  getUserAffinity as b8,
  getFeaturesData as b9,
  getMdsData as ba,
  getMdsSnapShotData as bb,
  getMdsWorkspaceData as bc,
  getProgressionsDict as bd,
  getProgressionStagesDict as be,
  getFlightsData as bf,
  getActiveGatesForFeatureAsync as bg,
  getFeatureScorecardsAsync as bh,
  getRootFeatureTreatmentFlights as bi,
  getMdsSnapShotsProgressionTemplatesWithAsync as bj,
  getMdsSnapShotsProgressionTemplates as bk,
  getProgressionIdOfProgressionStage as bl,
  getRootFeatureProgressionStagesOperations as bm,
  getProgressionStageOperationsAsync as bn,
  getExtraProgressionData as bo,
  getIsFlightGettingUsedInOverrides as bp,
  GatingActions as bq,
  fetchAndUpdateBudgetInfo as br,
  getResponseAsyncData as bs,
  getProgressionCloneGroupsInState as bt,
  getExperimentationGroupId as c,
  getShowVNextProgressionPage as d,
  epics as e,
  featureDataActions as f,
  getManagementGroup as g,
  getWorkspaceId as h,
  getRootFeatureAsync as i,
  getWorkspaceIsolationGroups as j,
  getMdsFlightControlAsync as k,
  getWorkspaceAssignmentUnits as l,
  getMdsProgressionTemplatesAsync as m,
  getMdsControlTowerExperienceAsync as n,
  overrideActions as o,
  getMdsExperimentExtensionsAsync as p,
  getMdsAnalysisConfigAsync as q,
  reducer as r,
  getMdsExperimentPermissionAsync as s,
  getMdsDefaultSnapshotAsync as t,
  getMdsExperimentTrafficFiltersAsync as u,
  getMdsExperimentTemplatesAsync as v,
  getMdsSnapShots as w,
  getRootFeatureProgressionsList as x,
  getRootFeatureProgressionsDict as y,
  getRootFeatureProgressionStages as z
};
//# sourceMappingURL=FeatureDataActions-59549dc8.js.map
